module.exports = {
    EN: {
        AUTHENTICATION: {
            TITLE: "Please confirm your email address",
            EMAIL_ADDRESS: {
                LABEL: "Email Address",
                ISSUE: {
                    INVALID: "Invalid Email Address"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Ticket Search",
            SUBTITLE: "Please enter ticket number and email address",
            TICKET_NUMBER: {
                LABEL: "Ticket Number",
                ISSUE: {
                    INVALID: "Invalid Ticket Number"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Email Address",
                ISSUE: {
                    INVALID: "Invalid Email Address"
                }
            },
            ISSUE: {
                NOT_FOUND: "Ticket not found",
                ERROR: "Error"
                //HELP_MESSAGE: "If the issue persists, please contact us at"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Confirmation Page for Return Merchandise Authorization",
            SUBTITLE: "Please complete the below form to start your return.",
            PERSONAL_INFORMATION: {
                TITLE: "Personal Information",
                FIRST_NAME: {
                    LABEL: "First name"
                },
                LAST_NAME: {
                    LABEL: "Last name"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Email address"
                },
                PHONE_NUMBER: {
                    LABEL: "Phone Number"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Replacement Address",
                TITLE: "Address",
                COUNTRY: {
                    LABEL: "Country"
                },
                FIRST_NAME: {
                    LABEL: "First name"
                },
                LAST_NAME: {
                    LABEL: "Last name"
                },
                ADDRESS_1: {
                    LABEL: "Address"
                },
                ADDRESS_2: {
                    LABEL: "Apartment, suite, etc. (optional)"
                },
                CITY: {
                    LABEL: "City"
                },
                PROVINCE: {
                    LABEL: "Province"
                },
                POSTAL_CODE: {
                    LABEL: "Postal code"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Return address is the same"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Return Address",
                COUNTRY: {
                    LABEL: "Country"
                },
                FIRST_NAME: {
                    LABEL: "First name"
                },
                LAST_NAME: {
                    LABEL: "Last name"
                },
                ADDRESS_1: {
                    LABEL: "Address"
                },
                ADDRESS_2: {
                    LABEL: "Apartment, suite, etc. (optional)"
                },
                CITY: {
                    LABEL: "City"
                },
                PROVINCE: {
                    LABEL: "Province"
                },
                POSTAL_CODE: {
                    LABEL: "Postal code"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Request",
                REQUEST_TYPE: {
                    LABEL: "Request Type"
                },
                RETURN_ITEMS: {
                    TITLE: "Items you are returning"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Items you are receiving"
                }
            },
            CONFIRMATION: {
                TITLE: "Confirmation",
                CUSTOMER_MESSAGE: {
                    TITLE: "Dear Customer",
                    STEPS: "1. Please verify and update your shipping information, if required.\r\n2. Verify your request information.\r\n3. Agree to the request by clicking on the checkbox below.\r\n4. Submit the request by clicking the SUBMIT button below.",
                    FOOTER: "Should you have any questions about your request, or require further assistance, please visit HELP.KOBO.COM for other contact options and support tools."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "I agree with defective items to be returned and to receive replacement items indicated in this request."
                }
            }
        },
        TICKET: {
            TITLE: "Return Merchandise Authorization",
            GENERAL_INFORMATION: {
                TITLE: "General Information",
                UPDATE_ADDRESS: "Update Address",
                PERSONAL_INFORMATION: {
                    TITLE: "Personal"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Replacement Address",
                    TITLE: "Address",
                    TITLE_SAME: "Address"
                },
                RETURN_ADDRESS: {
                    TITLE: "Return Address",
                    SAME_AS_REPLACEMENT_ADDRESS: "Same as replacement address"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Request",
                REQUEST_TYPE: {
                    LABEL: "Request Type"
                },
                RETURN_ITEMS: {
                    TITLE: "Items you are returning"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Items you are receiving"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Return Tracking Information"
                        LABEL: "Track Package"
                    },
                    OUTBOUND: {
                        //LABEL: "Replacement Tracking Information"
                        LABEL: "Track Package"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up blocked. Allow pop-ups for this site, or open tracking ",
                    POPUP_BLOCKED_LINK_LABEL: "here"
                },
                DOWNLOAD_RETURN_LABEL: "Download Return Label",
                RETURN_LABEL_PENDING: "Return Label Pending",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "RMA request was received.\r\nReturn labels will be created shortly.\r\nOnce the labels are created, you will receive an email containing return instructions.\r\nYou will also be able to download return labels on this page.",
                            RETURN_SHIPPED:
                                "Return items were shipped.\r\nPlease allow a couple of business days for items to arrive at our warehouse.\r\nPlease note: the warehouse needs a couple of business days to process the request after items arrive at the warehouse.",
                            RETURN_RECEIVED:
                                "Return items were processed by the warehouse.\r\nReplacement items will be shipped out within a couple of business days.",
                            SHIPMENT_SHIPPED: "Replacement items were shipped.\r\nPlease see tracking information below.",
                            SHIPMENT_DELIVERED: "Replacement items were  delivered."
                        },
                        REFUND: {
                            CREATED:
                                "RMA request was received.\r\nReturn labels will be created shortly.\r\nOnce the labels are created, you will receive an email containing return instructions.\r\nYou will also be able to download return labels on this page.",
                            RETURN_SHIPPED:
                                "Return items were shipped.\r\nPlease allow a couple of business days for items to arrive at our warehouse.\r\nPlease note: the warehouse needs a couple of business days to process the request after items arrive at the warehouse.",
                            RETURN_RECEIVED: "Return items were processed by the warehouse.\r\nRefund will be issued within a couple of business days.",
                            REFUNDED: "Refund was issued."
                        },
                        SHIP_ONLY: {
                            CREATED: "RMA request was received.\r\nReplacement items will be shipped within a couple of business days.",
                            SHIPMENT_SHIPPED: "Replacement items were shipped.\r\nPlease see tracking information below.",
                            SHIPMENT_DELIVERED: "Replacement shipment was delivered."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "RMA request was received.\r\nReturn labels will be created shortly.\r\nOnce the labels are created, you will receive an email containing return instructions.\r\nYou will also be able to download return labels on this page.",
                            RETURN_SHIPPED:
                                "Return items were shipped.\r\nPlease allow a couple of business days for items to arrive at our warehouse.\r\nPlease note: the warehouse needs a couple of business days to process the request after items arrive at the warehouse.",
                            RETURN_RECEIVED: "Return items were processed by the warehouse."
                        }
                    },
                    CREATED: {
                        TITLE: "Created",
                        DESCRIPTION: "RMA request has been created."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Address Verification Notice Sent",
                        DESCRIPTION: "Address verification email was sent to your email address."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Address Verified",
                        DESCRIPTION: "Address was verified."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Return Label Created",
                        DESCRIPTION: "Return labels have been created."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Return Notice Sent",
                    //     DESCRIPTION: "Return labels and instructions have been sent to your email address."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Return Final Notice Sent",
                    //     DESCRIPTION: "Return reminder has been sent to your email address."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Return Shipped",
                        DESCRIPTION: "Return has been shipped."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Return Received",
                        DESCRIPTION: "Warehouse has received the return items."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Return Received Notice Sent",
                    //     DESCRIPTION: "Warehouse has received the return."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Shipment Created",
                        DESCRIPTION: "Warehouse has prepared the shipment."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Shipment Shipped",
                        DESCRIPTION: "Warehouse has shipped the replacement items."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Shipment Shipped Notice Sent",
                    //     DESCRIPTION: "Shipment Shipped Notice Sent Description"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Shipment Delivered",
                        DESCRIPTION: "Shipment has been delivered."
                    },
                    REFUNDED: {
                        TITLE: "Refunded",
                        DESCRIPTION: "Refund has been issued."
                    },
                    CANCELLED: {
                        TITLE: "Cancelled",
                        DESCRIPTION: "RMA request has been cancelled."
                    },
                    CLOSED: {
                        TITLE: "Closed",
                        DESCRIPTION: "RMA request has been closed."
                    },
                    REACHED: "Status Reached",
                    UNREACHED: "Status Unreached"
                },
                TIMELINE: {
                    TITLE: "Request Timeline"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Related Tickets",
                TICKET_NUMBER: "Ticket Number",
                CREATED_DATE: "Created Date",
                REQUEST_TYPES: "Request Types",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Item",
            ORDER_REFERENCE: {
                LABEL: "Order Reference"
            },
            RETURN_REASON: {
                LABEL: "Return Reason"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Return Reason Description"
            },
            CONDITION: {
                LABEL: "Condition",
                VALUE: {
                    NEW: "New",
                    REFURBISHED: "Refurbished"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Order Reference",
            RETURN_REASON: "Return Reason",
            RETURN_REASON_DESCRIPTION: "Return Reason Description",
            CONDITION: {
                LABEL: "Condition",
                VALUE: {
                    NEW: "New",
                    REFURBISHED: "Refurbished"
                }
            },
            TYPE: {
                RETURN: "Return",
                REPLACEMENT: "Replacement"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "SUBMIT"
            },
            CANCEL: {
                LABEL: "CANCEL"
            },
            SEARCH: {
                LABEL: "SEARCH"
            },
            CLOSE: {
                LABEL: "CLOSE"
            },
            HELP: {
                LABEL: "HELP"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Replacement",
            REFUND: "Refund",
            RETURN_ONLY: "Return Only",
            SHIP_ONLY: "Ship Only"
        }
    },
    FR: {
        AUTHENTICATION: {
            TITLE: "Veuillez confirmer votre adresse e-mail",
            EMAIL_ADDRESS: {
                LABEL: "Adresse e-mail",
                ISSUE: {
                    INVALID: "Adresse e-mail non valide"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Recherche de billets",
            SUBTITLE: "Veuillez saisir le numéro de billet et l'adresse e-mail",
            TICKET_NUMBER: {
                LABEL: "Numéro de ticket",
                ISSUE: {
                    INVALID: "Numéro de ticket non valide"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Adresse e-mail",
                ISSUE: {
                    INVALID: "Adresse e-mail non valide"
                }
            },
            ISSUE: {
                NOT_FOUND: "Billet introuvable",
                ERROR: "Erreur"
                //HELP_MESSAGE: "If the issue persists, please contact us at"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Page de confirmation pour l'autorisation de retour de marchandise",
            SUBTITLE: "Veuillez remplir le formulaire ci-dessous pour commencer votre retour.",
            PERSONAL_INFORMATION: {
                TITLE: "Informations personnelles",
                FIRST_NAME: {
                    LABEL: "Prénom"
                },
                LAST_NAME: {
                    LABEL: "Nom"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Adresse e-mail"
                },
                PHONE_NUMBER: {
                    LABEL: "Numéro de téléphone"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Adresse de remplacement",
                TITLE: "Adresse",
                COUNTRY: {
                    LABEL: "Pays"
                },
                FIRST_NAME: {
                    LABEL: "Prénom"
                },
                LAST_NAME: {
                    LABEL: "Nom"
                },
                ADDRESS_1: {
                    LABEL: "Adresse"
                },
                ADDRESS_2: {
                    LABEL: "Appartement, suite, etc. (facultatif)"
                },
                CITY: {
                    LABEL: "Ville"
                },
                PROVINCE: {
                    LABEL: "Province"
                },
                POSTAL_CODE: {
                    LABEL: "Code postal"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "L'adresse de retour est la même"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Adresse de retour",
                COUNTRY: {
                    LABEL: "Pays"
                },
                FIRST_NAME: {
                    LABEL: "Prénom"
                },
                LAST_NAME: {
                    LABEL: "Nom"
                },
                ADDRESS_1: {
                    LABEL: "Adresse"
                },
                ADDRESS_2: {
                    LABEL: "Appartement, suite, etc. (facultatif)"
                },
                CITY: {
                    LABEL: "Ville"
                },
                PROVINCE: {
                    LABEL: "Province"
                },
                POSTAL_CODE: {
                    LABEL: "Code postal"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Demande",
                REQUEST_TYPE: {
                    LABEL: "Type de demande"
                },
                RETURN_ITEMS: {
                    TITLE: "Articles que vous retournez"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articles que vous recevez"
                }
            },
            CONFIRMATION: {
                TITLE: "Confirmation",
                CUSTOMER_MESSAGE: {
                    TITLE: "Cher/Chère client(e),",
                    STEPS: "1. Veuillez vérifier les informations de votre demande.\r\n2.Vérifiez votre adresse.\r\n3. Acceptez la demande en cochant la case ci-dessous.\r\n4. Soumettez la demande en cliquant sur le bouton ENVOYER ci-dessous.",
                    FOOTER: "Pour toute question concernant votre demande ou pour toute aide supplémentaire, veuillez consulter le site HELP.KOBO.COM pour découvrir d'autres options de contact ainsi que des outils d'assistance supplémentaires."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "J'accepte de retourner et de recevoir les articles indiqués dans cette demande."
                }
            }
        },
        TICKET: {
            TITLE: "Autorisation de retour de marchandise",
            GENERAL_INFORMATION: {
                TITLE: "Informations générales",
                UPDATE_ADDRESS: "Mettre à jour l'adresse",
                PERSONAL_INFORMATION: {
                    TITLE: "Personnel"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Adresse de remplacement",
                    TITLE: "Adresse",
                    TITLE_SAME: "Adresse"
                },
                RETURN_ADDRESS: {
                    TITLE: "Adresse de retour",
                    SAME_AS_REPLACEMENT_ADDRESS: "Identique à l'adresse de remplacement"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Demande",
                REQUEST_TYPE: {
                    LABEL: "Type de demande"
                },
                RETURN_ITEMS: {
                    TITLE: "Articles que vous retournez"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articles que vous recevez"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informations de suivi du retour"
                        LABEL: "Suivre ce colis"
                    },
                    OUTBOUND: {
                        //LABEL: "Informations de suivi de remplacement"
                        LABEL: "Suivre ce colis"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up bloque. Autorisez les pop-ups pour ce site, ou ouvrez le suivi ",
                    POPUP_BLOCKED_LINK_LABEL: "ici"
                },
                DOWNLOAD_RETURN_LABEL: "Télécharger l'étiquette de retour",
                RETURN_LABEL_PENDING: "Etiquette de retour en attente",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "La demande RMA a été reçue.\r\nDes étiquettes de retour seront créées prochainement.\r\nUne fois les étiquettes créées, vous recevrez un e-mail contenant les instructions de retour.\r\nVous pourrez également télécharger les étiquettes de retour sur cette page.",
                            RETURN_SHIPPED:
                                "Les articles retournés ont été expédiés. Veuillez prévoir quelques jours ouvrables pour que les articles arrivent à notre entrepôt.\r\nVeuillez noter que l'entrepôt a besoin de quelques jours ouvrables pour traiter la demande après l'arrivée des articles à l'entrepôt.",
                            RETURN_RECEIVED:
                                "Les articles retournés ont été traités par l'entrepôt.\r\nLes articles de remplacement seront expédiés dans un délai de quelques jours ouvrables.",
                            SHIPMENT_SHIPPED: "Des articles de remplacement ont été expédiés.\r\nVeuillez consulter les informations de suivi ci-dessous.",
                            SHIPMENT_DELIVERED: "Des articles de remplacement ont été livrés."
                        },
                        REFUND: {
                            CREATED:
                                "La demande RMA a été reçue.\r\nDes étiquettes de retour seront créées prochainement.\r\nUne fois les étiquettes créées, vous recevrez un e-mail contenant les instructions de retour.\r\nVous pourrez également télécharger les étiquettes de retour sur cette page.",
                            RETURN_SHIPPED:
                                "Les articles retournés ont été expédiés. Veuillez prévoir quelques jours ouvrables pour que les articles arrivent à notre entrepôt.\r\nVeuillez noter que l'entrepôt a besoin de quelques jours ouvrables pour traiter la demande après l'arrivée des articles à l'entrepôt.",
                            RETURN_RECEIVED:
                                "Les articles retournés ont été traités par l'entrepôt.\r\nLe remboursement sera effectué dans les deux jours ouvrables.",
                            REFUNDED: "Le remboursement a été effectué."
                        },
                        SHIP_ONLY: {
                            CREATED: "La demande RMA a été reçue.r\nLes articles de remplacement seront expédiés sous quelques jours ouvrables..",
                            SHIPMENT_SHIPPED: "Des articles de remplacement ont été expédiés.\r\nVeuillez consulter les informations de suivi ci-dessous..",
                            SHIPMENT_DELIVERED: "Un colis de remplacement a été livré."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "La demande RMA a été reçue.\r\nDes étiquettes de retour seront créées prochainement.\r\nUne fois les étiquettes créées, vous recevrez un e-mail contenant les instructions de retour.\r\nVous pourrez également télécharger les étiquettes de retour sur cette page.",
                            RETURN_SHIPPED:
                                "Les articles retournés ont été expédiés. Veuillez prévoir quelques jours ouvrables pour que les articles arrivent à notre entrepôt.\r\nVeuillez noter que l'entrepôt a besoin de quelques jours ouvrables pour traiter la demande après l'arrivée des articles à l'entrepôt.",
                            RETURN_RECEIVED: "Les articles retournés ont été traités par l'entrepôt."
                        }
                    },
                    CREATED: {
                        TITLE: "Créé",
                        DESCRIPTION: "La demande RMA a été créée."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Avis de vérification d'adresse envoyé",
                        DESCRIPTION: "L'e-mail de vérification d'adresse a été envoyé à votre adresse e-mail."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Adresse vérifiée",
                        DESCRIPTION: "L'adresse a été vérifiée."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Étiquette de retour créée",
                        DESCRIPTION: "Les étiquettes de retour ont été créées."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Avis de retour envoyé",
                    //     DESCRIPTION: "Les étiquettes de retour et les instructions ont été envoyées à votre adresse e-mail."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Retour de l'avis final envoyé",
                    //     DESCRIPTION: "Un rappel de retour a été envoyé à votre adresse e-mail."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Retour expédié",
                        DESCRIPTION: "Le retour a été expédié."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Retour reçu",
                        DESCRIPTION: "L'entrepôt a reçu les articles retournés."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Avis de réception du retour envoyé",
                    //     DESCRIPTION: "L'entrepôt a reçu le retour."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Expédition créée",
                        DESCRIPTION: "L'entrepôt a préparé l'expédition."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Expédition expédiée",
                        DESCRIPTION: "L'entrepôt a expédié les articles de remplacement."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Envoi d'un avis d'expédition",
                    //     DESCRIPTION: "Envoi d'un avis d'expédition"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Expédition livrée",
                        DESCRIPTION: "L'expédition a été livrée."
                    },
                    REFUNDED: {
                        TITLE: "Remboursé",
                        DESCRIPTION: "Les remboursements ont été émis."
                    },
                    CANCELLED: {
                        TITLE: "Résilié",
                        DESCRIPTION: "La demande RMA a été annulée."
                    },
                    CLOSED: {
                        TITLE: "Fermé",
                        DESCRIPTION: "La demande RMA a été clôturée."
                    },
                    REACHED: "Statut Atteint",
                    UNREACHED: "Statut Non Atteint"
                },
                TIMELINE: {
                    TITLE: "Demander le journal"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Tickets Associés",
                TICKET_NUMBER: "Numéro de ticket",
                CREATED_DATE: "Date de création",
                REQUEST_TYPES: "Types de demandes",
                STATUS: "Statut"
            }
        },
        ITEM: {
            LABEL: "Article",
            ORDER_REFERENCE: {
                LABEL: "Référence de commande"
            },
            RETURN_REASON: {
                LABEL: "Motif du retour"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Description du motif du retour"
            },
            CONDITION: {
                LABEL: "Condition",
                VALUE: {
                    NEW: "Nouveau",
                    REFURBISHED: "Actualisé"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Informations relatives à l'article",
            ORDER_REFERENCE: "Référence de commande",
            RETURN_REASON: "Motif du retour",
            RETURN_REASON_DESCRIPTION: "Description du motif du retour",
            CONDITION: {
                LABEL: "Condition",
                VALUE: {
                    NEW: "Nouveau",
                    REFURBISHED: "Actualisé"
                }
            },
            TYPE: {
                RETURN: "Retourner",
                REPLACEMENT: "Remplacement"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "ENVOYER"
            },
            CANCEL: {
                LABEL: "ANNULER"
            },
            SEARCH: {
                LABEL: "RECHERCHE"
            },
            CLOSE: {
                LABEL: "FERMER"
            },
            HELP: {
                LABEL: "AIDE"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Remplacement",
            REFUND: "Remboursement",
            RETURN_ONLY: "Retourner uniquement",
            SHIP_ONLY: "Expédier uniquement"
        }
    },
    DE: {
        AUTHENTICATION: {
            TITLE: "Bitte bestätigen Sie Ihre E-Mail-Adresse",
            EMAIL_ADDRESS: {
                LABEL: "eMail-Adresse",
                ISSUE: {
                    INVALID: "Ungültige E-Mail-Adresse"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Ticketsuche",
            SUBTITLE: "Bitte geben Sie die Ticketnummer und die E-Mail-Adresse ein.",
            TICKET_NUMBER: {
                LABEL: "Ticketnummer",
                ISSUE: {
                    INVALID: "Ungültige Ticketnummer"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "eMail-Adresse",
                ISSUE: {
                    INVALID: "Ungültige E-Mail-Adresse"
                }
            },
            ISSUE: {
                NOT_FOUND: "Ticket nicht gefunden",
                ERROR: "Fehler"
                //HELP_MESSAGE: "If the issue persists, please contact us at"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Bestätigungsseite für die Autorisierung zur Warenrückgabe",
            SUBTITLE: "Bitte füllen Sie das untenstehende Formular aus, um Ihre Rücksendung zu starten.",
            PERSONAL_INFORMATION: {
                TITLE: "Personenbezogene Daten",
                FIRST_NAME: {
                    LABEL: "Vorname"
                },
                LAST_NAME: {
                    LABEL: "Nachname"
                },
                EMAIL_ADDRESS: {
                    LABEL: "eMail-Adresse"
                },
                PHONE_NUMBER: {
                    LABEL: "Telefonnummer"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Ersatz-Adresse",
                TITLE: "Adresse",
                COUNTRY: {
                    LABEL: "Land"
                },
                FIRST_NAME: {
                    LABEL: "Vorname"
                },
                LAST_NAME: {
                    LABEL: "Nachname"
                },
                ADDRESS_1: {
                    LABEL: "Adresse"
                },
                ADDRESS_2: {
                    LABEL: "Wohnung, Suite, usw. (optional)"
                },
                CITY: {
                    LABEL: "Ort"
                },
                PROVINCE: {
                    LABEL: "Region"
                },
                POSTAL_CODE: {
                    LABEL: "Postleitzahl"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Die Rücksendeadresse ist dieselbe"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Absenderadresse",
                COUNTRY: {
                    LABEL: "Land"
                },
                FIRST_NAME: {
                    LABEL: "Vorname"
                },
                LAST_NAME: {
                    LABEL: "Nachname"
                },
                ADDRESS_1: {
                    LABEL: "Adresse"
                },
                ADDRESS_2: {
                    LABEL: "Wohnung, Suite, usw. (optional)"
                },
                CITY: {
                    LABEL: "Ort"
                },
                PROVINCE: {
                    LABEL: "Region"
                },
                POSTAL_CODE: {
                    LABEL: "Postleitzahl"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Anfrage",
                REQUEST_TYPE: {
                    LABEL: "Art der Anforderung"
                },
                RETURN_ITEMS: {
                    TITLE: "Artikel, die Sie zurücksenden"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artikel, die Sie erhalten"
                }
            },
            CONFIRMATION: {
                TITLE: "Bestätigung",
                CUSTOMER_MESSAGE: {
                    TITLE: "Sehr geehrter Kunde,",
                    STEPS: "1. Bitte überprüfen Sie die Daten zu Ihrer Anfrage.\r\n2. Überprüfen und bestätigen Sie Ihre Adresse.\r\n3. Stimmen Sie der Anfrage zu, indem Sie das Kästchen unten anklicken.\r\n4. Senden Sie die Anfrage, indem Sie unten auf die Schaltfläche SENDEN klicken.",
                    FOOTER: "Sollten Sie Fragen zu Ihrer Anfrage haben oder weitere Hilfe benötigen, besuchen Sie bitte HELP.KOBO.COM für weitere Kontaktmöglichkeiten und Support-Tools."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "ich erkläre mich damit einverstanden, die in diesem Antrag angegebenen Artikel zurückzusenden und zu erhalten."
                }
            }
        },
        TICKET: {
            TITLE: "Rücksendegenehmigung für Waren",
            GENERAL_INFORMATION: {
                TITLE: "Allgemeine Informationen",
                UPDATE_ADDRESS: "Adresse aktualisieren",
                PERSONAL_INFORMATION: {
                    TITLE: "Persönlich"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Ersatz-Adresse",
                    TITLE: "Adresse",
                    TITLE_SAME: "Adresse"
                },
                RETURN_ADDRESS: {
                    TITLE: "Absenderadresse",
                    SAME_AS_REPLACEMENT_ADDRESS: "Entspricht der Ersatzadresse"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Anfrage",
                REQUEST_TYPE: {
                    LABEL: "Art der Anforderung"
                },
                RETURN_ITEMS: {
                    TITLE: "Artikel, die Sie zurücksenden"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artikel, die Sie erhalten"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informationen zur Sendungsverfolgung zurücksenden"
                        LABEL: "Paket nachverfolgen"
                    },
                    OUTBOUND: {
                        //LABEL: "Informationen zur Nachverfolgung von Ersatzteilen"
                        LABEL: "Paket nachverfolgen"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up blockiert. Erlauben Sie Pop-ups fur diese Website, oder offnen Sie die Sendungsverfolgung ",
                    POPUP_BLOCKED_LINK_LABEL: "hier"
                },
                DOWNLOAD_RETURN_LABEL: "Retourenlabel herunterladen",
                RETURN_LABEL_PENDING: "Rücksendeetikett ausstehend",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Die RMA-Anfrage wurde erhalten.\r\nRücksendeetiketten werden in Kürze erstellt.\r\nSobald die Etiketten erstellt sind, erhalten Sie eine E-Mail mit Rücksendeanweisungen.\r\nAuf dieser Seite können Sie auch Rücksendeetiketten herunterladen.",
                            RETURN_SHIPPED:
                                "Rücksendeartikel wurden versendet.\r\nBitte rechnen Sie mit ein paar Werktagen, bis die Artikel in unserem Lager eintreffen.\r\nBitte beachten Sie, dass das Lager ein paar Werktage braucht, um die Anfrage zu bearbeiten, nachdem die Artikel im Lager eingetroffen sind.",
                            RETURN_RECEIVED: "Retourenartikel wurden vom Lager bearbeitet.\r\nErsatzartikel werden innerhalb weniger Werktage versendet.",
                            SHIPMENT_SHIPPED: "Ersatzartikel wurden versandt.\r\nBitte beachten Sie die Tracking-Informationen unten.",
                            SHIPMENT_DELIVERED: "Ersatzartikel wurden geliefert."
                        },
                        REFUND: {
                            CREATED:
                                "Die RMA-Anfrage wurde erhalten.\r\nRücksendeetiketten werden in Kürze erstellt.\r\nSobald die Etiketten erstellt sind, erhalten Sie eine E-Mail mit Rücksendeanweisungen.\r\nAuf dieser Seite können Sie auch Rücksendeetiketten herunterladen.",
                            RETURN_SHIPPED:
                                "Rücksendeartikel wurden versendet.\r\nBitte rechnen Sie mit ein paar Werktagen, bis die Artikel in unserem Lager eintreffen.\r\nBitte beachten Sie, dass das Lager ein paar Werktage braucht, um die Anfrage zu bearbeiten, nachdem die Artikel im Lager eingetroffen sind.",
                            RETURN_RECEIVED: "Retourenartikel wurden vom Lager bearbeitet.\r\nDie Rückerstattung erfolgt innerhalb weniger Werktage.",
                            REFUNDED: "Rückerstattung wurde ausgestellt."
                        },
                        SHIP_ONLY: {
                            CREATED: "Die RMA-Anfrage wurde erhalten.\r\nErsatzartikel werden innerhalb weniger Werktage versendet.",
                            SHIPMENT_SHIPPED: "Ersatzartikel wurden versandt. Bitte beachten Sie die Tracking-Informationen unten.",
                            SHIPMENT_DELIVERED: "Die Ersatzsendung wurde geliefert."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Die RMA-Anfrage wurde erhalten.\r\nRücksendeetiketten werden in Kürze erstellt.\r\nSobald die Etiketten erstellt sind, erhalten Sie eine E-Mail mit Rücksendeanweisungen.\r\nAuf dieser Seite können Sie auch Rücksendeetiketten herunterladen.",
                            RETURN_SHIPPED:
                                "Rücksendeartikel wurden versendet.\r\nBitte rechnen Sie mit ein paar Werktagen, bis die Artikel in unserem Lager eintreffen.\r\nBitte beachten Sie, dass das Lager ein paar Werktage braucht, um die Anfrage zu bearbeiten, nachdem die Artikel im Lager eingetroffen sind.",
                            RETURN_RECEIVED: "Retourenartikel wurden vom Lager bearbeitet."
                        }
                    },
                    CREATED: {
                        TITLE: "Erstellt",
                        DESCRIPTION: "Die RMA-Anfrage wurde erstellt."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Adressverifizierungsbenachrichtigung gesendet",
                        DESCRIPTION: "Die E-Mail zur Adressverifizierung wurde an Ihre E-Mail-Adresse gesendet."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Adresse bestätigt",
                        DESCRIPTION: "Die Adresse wurde verifiziert."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Rücksendeetikett erstellt",
                        DESCRIPTION: "Rücksendeetiketten wurden erstellt."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Rücksendebenachrichtigung gesendet",
                    //     DESCRIPTION: "Rücksendeetiketten und Anweisungen wurden an Ihre E-Mail-Adresse geschickt."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Rückgabe der endgültigen Mitteilung gesendet",
                    //     DESCRIPTION: "Eine Erinnerung wurde an Ihre E-Mail-Adresse gesendet."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Rückversand",
                        DESCRIPTION: "Die Rücksendung wurde verschickt."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Rückgabe erhalten",
                        DESCRIPTION: "Das Lager hat die retournierten Artikel erhalten."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Rücksendebenachrichtigung gesendet",
                    //     DESCRIPTION: "Das Lager hat die Rücksendung erhalten."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Versand wurde erstellt",
                        DESCRIPTION: "Das Lager hat die Lieferung vorbereitet."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Versand versendet",
                        DESCRIPTION: "Das Lager hat die Ersatzartikel versandt."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Sendung versandt Benachrichtigung gesendet",
                    //     DESCRIPTION: "Sendung versandt Benachrichtigung gesendet Beschreibung"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Lieferung zugestellt",
                        DESCRIPTION: "Die Lieferung wurde zugestellt."
                    },
                    REFUNDED: {
                        TITLE: "Rückerstattet",
                        DESCRIPTION: "Die Rückerstattung wurde ausgestellt."
                    },
                    CANCELLED: {
                        TITLE: "Gekündigt",
                        DESCRIPTION: "Die RMA-Anfrage wurde storniert."
                    },
                    CLOSED: {
                        TITLE: "Geschlossen",
                        DESCRIPTION: "Die RMA-Anfrage wurde geschlossen."
                    },
                    REACHED: "Status Erreicht",
                    UNREACHED: "Status Nicht Erreicht"
                },
                TIMELINE: {
                    TITLE: "Zeitstrahl anfordern"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Verwandte Tickets",
                TICKET_NUMBER: "Ticketnummer",
                CREATED_DATE: "Erstellungsdatum",
                REQUEST_TYPES: "Anforderungs-Typen",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Artikel",
            ORDER_REFERENCE: {
                LABEL: "Bestellreferenz"
            },
            RETURN_REASON: {
                LABEL: "Grund für die Rückgabe"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Beschreibung des Rückgabegrundes"
            },
            CONDITION: {
                LABEL: "Zustand",
                VALUE: {
                    NEW: "Neu",
                    REFURBISHED: "Generalüberholt"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Artikeldetails",
            ORDER_REFERENCE: "Bestellreferenz",
            RETURN_REASON: "Grund für die Rückgabe",
            RETURN_REASON_DESCRIPTION: "Beschreibung des Rückgabegrundes",
            CONDITION: {
                LABEL: "Zustand",
                VALUE: {
                    NEW: "Neu",
                    REFURBISHED: "Generalüberholt"
                }
            },
            TYPE: {
                RETURN: "Zurück",
                REPLACEMENT: "Ersatz"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "ABSCHICKEN"
            },
            CANCEL: {
                LABEL: "ABBRECHEN"
            },
            SEARCH: {
                LABEL: "SUCHE"
            },
            CLOSE: {
                LABEL: "SCHLIESSEN"
            },
            HELP: {
                LABEL: "HELFEN"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Ersatz",
            REFUND: "Erstattung",
            RETURN_ONLY: "Nur zurück",
            SHIP_ONLY: "Nur Versand"
        }
    },
    ES: {
        AUTHENTICATION: {
            TITLE: "Confirma tu dirección de correo electrónico",
            EMAIL_ADDRESS: {
                LABEL: "Dirección de correo electrónico",
                ISSUE: {
                    INVALID: "Dirección de correo electrónico no válida"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Búsqueda de solicitud de soporte",
            SUBTITLE: "Introduce el número de solicitud de soporte y la dirección de correo electrónico.",
            TICKET_NUMBER: {
                LABEL: "Número de solicitud de soporte",
                ISSUE: {
                    INVALID: "Número de solicitud de soporte no válido"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Dirección de correo electrónico",
                ISSUE: {
                    INVALID: "Dirección de correo electrónico no válida"
                }
            },
            ISSUE: {
                NOT_FOUND: "Solicitud de soporte no encontrada",
                ERROR: "Error"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Página de confirmación para la autorización de devolución de mercancía",
            SUBTITLE: "Completa el siguiente formulario para iniciar tu devolución.",
            PERSONAL_INFORMATION: {
                TITLE: "Datos personales",
                FIRST_NAME: {
                    LABEL: "Nombre"
                },
                LAST_NAME: {
                    LABEL: "Apellidos"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Dirección de correo electrónico"
                },
                PHONE_NUMBER: {
                    LABEL: "Número de teléfono"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Dirección de sustitución",
                TITLE: "Dirección",
                COUNTRY: {
                    LABEL: "País"
                },
                FIRST_NAME: {
                    LABEL: "Nombre"
                },
                LAST_NAME: {
                    LABEL: "Apellidos"
                },
                ADDRESS_1: {
                    LABEL: "Dirección"
                },
                ADDRESS_2: {
                    LABEL: "Apartamento, suite, etc. (opcional)"
                },
                CITY: {
                    LABEL: "Ciudad"
                },
                PROVINCE: {
                    LABEL: "Provincia"
                },
                POSTAL_CODE: {
                    LABEL: "Código postal"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "La dirección de devolución es la misma"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Dirección de devolución",
                COUNTRY: {
                    LABEL: "País"
                },
                FIRST_NAME: {
                    LABEL: "Nombre"
                },
                LAST_NAME: {
                    LABEL: "Apellidos"
                },
                ADDRESS_1: {
                    LABEL: "Dirección"
                },
                ADDRESS_2: {
                    LABEL: "Apartamento, suite, etc. (opcional)"
                },
                CITY: {
                    LABEL: "Ciudad"
                },
                PROVINCE: {
                    LABEL: "Provincia"
                },
                POSTAL_CODE: {
                    LABEL: "Código postal"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Solicitud",
                REQUEST_TYPE: {
                    LABEL: "Tipo de solicitud"
                },
                RETURN_ITEMS: {
                    TITLE: "Artículos que devuelves"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artículos que recibes"
                }
            },
            CONFIRMATION: {
                TITLE: "Confirmación",
                CUSTOMER_MESSAGE: {
                    TITLE: "Estimado cliente:",
                    STEPS: "1. Revisa y asegúrate de que la información de tu solicitud esté correcta.\r\n2. Revisa y confirma tu dirección.\r\n3. Para aceptar la solicitud, haz clic en la casilla de verificación a continuación.\r\n4. Pulsa ENVIAR más abajo para completar la solicitud.",
                    FOOTER: "En caso de que tengas alguna pregunta sobre tu solicitud o necesites más ayuda, por favor visita HELP.KOBO.COM para encontrar otras opciones de contacto y herramientas de soporte."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Acepto devolver y recibir los artículos indicados en esta solicitud."
                }
            }
        },
        TICKET: {
            TITLE: "Autorización de devolución de mercancía",
            GENERAL_INFORMATION: {
                TITLE: "Información general",
                UPDATE_ADDRESS: "Actualizar dirección",
                PERSONAL_INFORMATION: {
                    TITLE: "Personal"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Dirección de sustitución",
                    TITLE: "Dirección",
                    TITLE_SAME: "Dirección"
                },
                RETURN_ADDRESS: {
                    TITLE: "Dirección de devolución",
                    SAME_AS_REPLACEMENT_ADDRESS: "Igual que la dirección de sustitución"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Solicitud",
                REQUEST_TYPE: {
                    LABEL: "Tipo de solicitud"
                },
                RETURN_ITEMS: {
                    TITLE: "Artículos que devuelves"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artículos que recibes"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Información de seguimiento de la devolución"
                        LABEL: "Seguimiento del paquete"
                    },
                    OUTBOUND: {
                        //LABEL: "Información de seguimiento de la sustitución"
                        LABEL: "Seguimiento del paquete"
                    },
                    POPUP_BLOCKED_PREFIX: "Ventana emergente bloqueada. Permite las ventanas emergentes para este sitio o abre el seguimiento ",
                    POPUP_BLOCKED_LINK_LABEL: "aqui"
                },
                DOWNLOAD_RETURN_LABEL: "Descargar etiqueta de devolución",
                RETURN_LABEL_PENDING: "Etiqueta de devolución pendiente",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Hemos recibido tu solicitud de RMA.\r\nLas etiquetas de devolución se crearán en breve.\r\nUna vez creadas, recibirás un correo electrónico con las instrucciones de devolución.\r\nTambién podrás descargar las etiquetas de devolución en esta página.",
                            RETURN_SHIPPED:
                                "Se enviaron los artículos devueltos.\r\nPor favor, espera unos días para que lleguen a nuestro almacén.\r\nTen en cuenta que necesitaremos un par de días hábiles adicionales para procesar la solicitud una vez que los artículos estén en el almacén.",
                            RETURN_RECEIVED:
                                "El almacén ha procesado los artículos devueltos.\r\nLos artículos de sustitución se enviarán en un par de días hábiles.",
                            SHIPMENT_SHIPPED: "Se enviaron los artículos de sustitución.\r\nConsulta la información de seguimiento a continuación.",
                            SHIPMENT_DELIVERED: "Se entregaron los artículos de sustitución."
                        },
                        REFUND: {
                            CREATED:
                                "Hemos recibido tu solicitud de RMA.\r\nLas etiquetas de devolución se crearán en breve.\r\nUna vez creadas, recibirás un correo electrónico con las instrucciones de devolución.\r\nTambién podrás descargar las etiquetas de devolución en esta página.",
                            RETURN_SHIPPED:
                                "Se enviaron los artículos devueltos.\r\nPor favor, espera unos días para que lleguen a nuestro almacén.\r\nTen en cuenta que necesitaremos un par de días hábiles adicionales para procesar la solicitud una vez que los artículos estén en el almacén.",
                            RETURN_RECEIVED:
                                "El almacén ha procesado los artículos devueltos.\r\nLos artículos de sustitución se enviarán en un par de días hábiles.",
                            REFUNDED: "Se ha emitido el reembolso."
                        },
                        SHIP_ONLY: {
                            CREATED: "Hemos recibido tu solicitud de RMA.\r\nLos artículos de sustitución se enviarán en un par de días hábiles.",
                            SHIPMENT_SHIPPED: "Se enviaron los artículos de sustitución.\r\nConsulta la información de seguimiento a continuación.",
                            SHIPMENT_DELIVERED: "Se entregaron los artículos de sustitución."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Hemos recibido tu solicitud de RMA.\r\nLas etiquetas de devolución se crearán en breve.\r\nUna vez creadas, recibirás un correo electrónico con las instrucciones de devolución.\r\nTambién podrás descargar las etiquetas de devolución en esta página.",
                            RETURN_SHIPPED:
                                "Se enviaron los artículos devueltos.\r\nPor favor, espera unos días para que lleguen a nuestro almacén.\r\nTen en cuenta que necesitaremos un par de días hábiles adicionales para procesar la solicitud una vez que los artículos estén en el almacén.",
                            RETURN_RECEIVED: "El almacén ha procesado los artículos devueltos."
                        }
                    },
                    CREATED: {
                        TITLE: "Creado",
                        DESCRIPTION: "Se ha creado la solicitud de RMA."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Aviso de verificación de dirección enviado",
                        DESCRIPTION: "Te hemos mandado un correo para verificar tu dirección."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Dirección verificada",
                        DESCRIPTION: "Se verificó la dirección."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Etiqueta de devolución creada",
                        DESCRIPTION: "Se han creado las etiquetas de devolución."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Aviso de devolución enviado",
                    //     DESCRIPTION: "Se han enviado las etiquetas y las instrucciones de devolución a tu dirección de correo electrónico."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Aviso final de devolución enviado",
                    //     DESCRIPTION: "Te hemos mandado un recordatorio de devolución a tu correo."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Artículos devueltos enviados",
                        DESCRIPTION: "Se enviaron los artículos devueltos."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Artículos devueltos recibidos",
                        DESCRIPTION: "El almacén ha recibido los artículos devueltos."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Aviso de recepción de los artículos devueltos enviado",
                    //     DESCRIPTION: "El almacén ha recibido la devolución."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Envío creado",
                        DESCRIPTION: "El almacén ha preparado el envío."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Paquete enviado",
                        DESCRIPTION: "El almacén ha enviado los artículos de sustitución."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Aviso de paquete enviado",
                    //     DESCRIPTION: "Aviso de paquete enviado"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Paquete entregado",
                        DESCRIPTION: "El paquete ha sido entregado."
                    },
                    REFUNDED: {
                        TITLE: "Reembolsado",
                        DESCRIPTION: "Se ha emitido el reembolso."
                    },
                    CANCELLED: {
                        TITLE: "Cancelado",
                        DESCRIPTION: "Se ha cerrado la solicitud de RMA."
                    },
                    CLOSED: {
                        TITLE: "Cerrado",
                        DESCRIPTION: "Se ha cerrado la solicitud de RMA."
                    },
                    REACHED: "Estado Alcanzado",
                    UNREACHED: "Estado No Alcanzado"
                },
                TIMELINE: {
                    TITLE: "Plazo de solicitud"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Solicitudes Relacionadas",
                TICKET_NUMBER: "Número de solicitud de soporte",
                CREATED_DATE: "Fecha de creación",
                REQUEST_TYPES: "Tipos de solicitud",
                STATUS: "Estado"
            }
        },
        ITEM: {
            LABEL: "Artículo",
            ORDER_REFERENCE: {
                LABEL: "Referencia del pedido"
            },
            RETURN_REASON: {
                LABEL: "Motivo de la devolución"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Descripción del motivo de la devolución"
            },
            CONDITION: {
                LABEL: "Condición",
                VALUE: {
                    NEW: "Nuevo",
                    REFURBISHED: "Restaurado"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Referencia del pedido",
            RETURN_REASON: "Motivo de la devolución",
            RETURN_REASON_DESCRIPTION: "Descripción del motivo de la devolución",
            CONDITION: {
                LABEL: "Condición",
                VALUE: {
                    NEW: "Nuevo",
                    REFURBISHED: "Restaurado"
                }
            },
            TYPE: {
                RETURN: "Devolver",
                REPLACEMENT: "Sustitución"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "ENVIAR"
            },
            CANCEL: {
                LABEL: "CANCELAR"
            },
            SEARCH: {
                LABEL: "BUSCAR"
            },
            CLOSE: {
                LABEL: "CERRAR"
            },
            HELP: {
                LABEL: "AYUDA"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Sustitución",
            REFUND: "Reembolso",
            RETURN_ONLY: "Solo devolución",
            SHIP_ONLY: "Solo envío"
        }
    },
    IT: {
        AUTHENTICATION: {
            TITLE: "Conferma il tuo indirizzo email",
            EMAIL_ADDRESS: {
                LABEL: "Indirizzo email",
                ISSUE: {
                    INVALID: "Indirizzo email non valido"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Cerca ticket",
            SUBTITLE: "Inserisci il numero del ticket e l'indirizzo email",
            TICKET_NUMBER: {
                LABEL: "Numero del ticket",
                ISSUE: {
                    INVALID: "Numero del ticket non valido"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Indirizzo email",
                ISSUE: {
                    INVALID: "Indirizzo email non valido"
                }
            },
            ISSUE: {
                NOT_FOUND: "Ticket non rinvenuto",
                ERROR: "Errore"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Pagina di conferma per l'autorizzazione alla restituzione della merce",
            SUBTITLE: "Compila il modulo sottostante per avviare il reso.",
            PERSONAL_INFORMATION: {
                TITLE: "Informazioni Personali",
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Cognome"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Indirizzo email"
                },
                PHONE_NUMBER: {
                    LABEL: "Numero di telefono"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Indirizzo per la sostituzione",
                TITLE: "Indirizzo",
                COUNTRY: {
                    LABEL: "Paese"
                },
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Cognome"
                },
                ADDRESS_1: {
                    LABEL: "Indirizzo"
                },
                ADDRESS_2: {
                    LABEL: "Appartamento, suite, ecc. (opzionale)"
                },
                CITY: {
                    LABEL: "Città"
                },
                PROVINCE: {
                    LABEL: "Provincia"
                },
                POSTAL_CODE: {
                    LABEL: "Codice postale"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "L'indirizzo per il reso è lo stesso"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Indirizzo del reso",
                COUNTRY: {
                    LABEL: "Paese"
                },
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Cognome"
                },
                ADDRESS_1: {
                    LABEL: "Indirizzo"
                },
                ADDRESS_2: {
                    LABEL: "Appartamento, suite, ecc. (opzionale)"
                },
                CITY: {
                    LABEL: "Città"
                },
                PROVINCE: {
                    LABEL: "Provincia"
                },
                POSTAL_CODE: {
                    LABEL: "Codice postale"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Richiesta",
                REQUEST_TYPE: {
                    LABEL: "Tipo di richiesta"
                },
                RETURN_ITEMS: {
                    TITLE: "Articoli che restituisci"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articoli che ricevi"
                }
            },
            CONFIRMATION: {
                TITLE: "Conferma",
                CUSTOMER_MESSAGE: {
                    TITLE: "Gentile cliente,",
                    STEPS: "1. Rivedere e verificare le informazioni della richiesta.\r\n2. Rivedere e verificare l'indirizzo.\r\n3. Accettare la richiesta facendo clic sulla casella sottostante.\r\n4. Inviare la richiesta facendo clic sul pulsante INVIA qui sotto.",
                    FOOTER: "In caso di domande sulla tua richiesta o per richiedere ulteriore assistenza, visita HELP.KOBO.COM per altre opzioni di contatto e strumenti di assistenza."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Accetto di restituire e ricevere gli articoli indicati in questa richiesta."
                }
            }
        },
        TICKET: {
            TITLE: "Autorizzazione al reso della merce",
            GENERAL_INFORMATION: {
                TITLE: "Informazioni generali",
                UPDATE_ADDRESS: "Aggiorna l'indirizzo",
                PERSONAL_INFORMATION: {
                    TITLE: "Personale"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Indirizzo per la sostituzione",
                    TITLE: "Indirizzo",
                    TITLE_SAME: "Indirizzo"
                },
                RETURN_ADDRESS: {
                    TITLE: "Indirizzo del reso",
                    SAME_AS_REPLACEMENT_ADDRESS: "Stesso indirizzo della sostituzione"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Richiesta",
                REQUEST_TYPE: {
                    LABEL: "Tipo di richiesta"
                },
                RETURN_ITEMS: {
                    TITLE: "Articoli che restituisci"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articoli che ricevi"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informazioni di tracciamento del reso"
                        LABEL: "Rintraccia il pacco"
                    },
                    OUTBOUND: {
                        //LABEL: "Informazioni sul monitoraggio della sostituzione"
                        LABEL: "Rintraccia il pacco"
                    },
                    POPUP_BLOCKED_PREFIX: "Popup bloccato. Consenti i popup per questo sito oppure apri il tracciamento ",
                    POPUP_BLOCKED_LINK_LABEL: "qui"
                },
                DOWNLOAD_RETURN_LABEL: "Scarica l'etichetta di reso",
                RETURN_LABEL_PENDING: "Etichetta di reso in attesa",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Richiesta di RMA ricevuta.\r\nLe etichette per i resi verranno create a breve.\r\nUna volta create le etichette, riceverai un'e-mail contenente le istruzioni per il reso.\r\nSarai quindi in grado di scaricare le etichette di reso su questa pagina.",
                            RETURN_SHIPPED:
                                "Gli articoli restituiti sono stati spediti.\r\nAttendere un paio di giorni lavorativi affinché gli articoli arrivino al nostro magazzino.\r\nNota: il magazzino ha bisogno di un paio di giorni lavorativi per elaborare la richiesta dopo l'arrivo degli articoli.",
                            RETURN_RECEIVED:
                                "Gli articoli restituiti sono stati elaborati dal magazzino.\r\nGli articoli sostitutivi verranno spediti entro un paio di giorni lavorativi.",
                            SHIPMENT_SHIPPED:
                                "Gli articoli sostitutivi sono stati spediti.\r\nQui di seguito trovi le informazioni per tracciare la spedizione.",
                            SHIPMENT_DELIVERED: "Gli articoli sostitutivi sono stati consegnati."
                        },
                        REFUND: {
                            CREATED:
                                "Richiesta di RMA ricevuta.\r\nLe etichette per i resi verranno create a breve.\r\nUna volta create le etichette, riceverai un'e-mail contenente le istruzioni per il reso.\r\nSarai quindi in grado di scaricare le etichette di reso su questa pagina.",
                            RETURN_SHIPPED:
                                "Gli articoli restituiti sono stati spediti.\r\nAttendere un paio di giorni lavorativi affinché gli articoli arrivino al nostro magazzino.\r\nNota: il magazzino ha bisogno di un paio di giorni lavorativi per elaborare la richiesta dopo l'arrivo degli articoli.",
                            RETURN_RECEIVED:
                                "Gli articoli restituiti sono stati elaborati dal magazzino.\r\nGli articoli sostitutivi verranno spediti entro un paio di giorni lavorativi.",
                            REFUNDED: "Rimborso emesso.."
                        },
                        SHIP_ONLY: {
                            CREATED: "Richiesta di RMA ricevuta.\r\nGli articoli sostitutivi verranno spediti entro un paio di giorni lavorativi.",
                            SHIPMENT_SHIPPED:
                                "Gli articoli sostitutivi sono stati spediti.\r\nQui di seguito trovi le informazioni per tracciare la spedizione.",
                            SHIPMENT_DELIVERED: "Gli articoli sostitutivi sono stati consegnati."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Richiesta di RMA ricevuta.\r\nLe etichette per i resi verranno create a breve.\r\nUna volta create le etichette, riceverai un'e-mail contenente le istruzioni per il reso.\r\nSarai quindi in grado di scaricare le etichette di reso su questa pagina.",
                            RETURN_SHIPPED:
                                "Gli articoli restituiti sono stati spediti.\r\nAttendere un paio di giorni lavorativi affinché gli articoli arrivino al nostro magazzino.\r\nNota: il magazzino ha bisogno di un paio di giorni lavorativi per elaborare la richiesta dopo l'arrivo degli articoli.",
                            RETURN_RECEIVED: "Gli articoli restituiti sono stati elaborati dal magazzino."
                        }
                    },
                    CREATED: {
                        TITLE: "Creato",
                        DESCRIPTION: "Richiesta di RMA creata."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Avviso di verifica dell'indirizzo inviato",
                        DESCRIPTION: "L'email di verifica dell'indirizzo è stata inviata al tuo indirizzo email."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Indirizzo verificato",
                        DESCRIPTION: "L'indirizzo è stato verificato."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Etichetta di reso creata",
                        DESCRIPTION: "Le etichette di reso sono state create."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Avviso di reso inviato",
                    //     DESCRIPTION: "Le etichette di reso e le istruzioni sono state inviate al tuo indirizzo email."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Avviso finale di reso inviato",
                    //     DESCRIPTION: "Ti è stato inviato un promemoria all'indirizzo email."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Reso spedito",
                        DESCRIPTION: "Il reso è stato spedito."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Reso ricevuto",
                        DESCRIPTION: "Il magazzino ha ricevuto gli articoli restituiti."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Avviso di reso ricevuto inviato",
                    //     DESCRIPTION: "Il magazzino ha ricevuto il reso."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Spedizione creata",
                        DESCRIPTION: "Il magazzino ha preparato la spedizione."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Spedizione inviata",
                        DESCRIPTION: "Il magazzino ha spedito gli articoli sostitutivi."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Avviso di spedizione inviato",
                    //     DESCRIPTION: "Avviso di spedizione inviato"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Spedizione consegnata",
                        DESCRIPTION: "La spedizione è stata consegnata."
                    },
                    REFUNDED: {
                        TITLE: "Rimborsato",
                        DESCRIPTION: "I rimborsi sono stati emessi."
                    },
                    CANCELLED: {
                        TITLE: "Annullato",
                        DESCRIPTION: "La richiesta di RMA è stata chiusa."
                    },
                    CLOSED: {
                        TITLE: "Chiuso",
                        DESCRIPTION: "La richiesta di RMA è stata chiusa."
                    },
                    REACHED: "Stato Raggiunto",
                    UNREACHED: "Stato Non Raggiunto"
                },
                TIMELINE: {
                    TITLE: "Cronologia delle richieste"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Ticket Correlati",
                TICKET_NUMBER: "Numero del ticket",
                CREATED_DATE: "Data di creazione",
                REQUEST_TYPES: "Tipi di richiesta",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Articolo",
            ORDER_REFERENCE: {
                LABEL: "Riferimento ordine"
            },
            RETURN_REASON: {
                LABEL: "Motivo del reso"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Descrizione del motivo del reso"
            },
            CONDITION: {
                LABEL: "Condizioni",
                VALUE: {
                    NEW: "Nuovo",
                    REFURBISHED: "Rinnovato"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Riferimento ordine",
            RETURN_REASON: "Motivo del reso",
            RETURN_REASON_DESCRIPTION: "Descrizione del motivo del reso",
            CONDITION: {
                LABEL: "Condizioni",
                VALUE: {
                    NEW: "Nuovo",
                    REFURBISHED: "Rinnovato"
                }
            },
            TYPE: {
                RETURN: "Ripristina",
                REPLACEMENT: "Sostituzione"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "INVIA"
            },
            CANCEL: {
                LABEL: "ANNULLA"
            },
            SEARCH: {
                LABEL: "CERCA"
            },
            CLOSE: {
                LABEL: "CHIUDI"
            },
            HELP: {
                LABEL: "AIUTO"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Sostituzione",
            REFUND: "Rimborso",
            RETURN_ONLY: "Solo resi",
            SHIP_ONLY: "Solo spedizione"
        }
    },
    PT: {
        AUTHENTICATION: {
            TITLE: "Confirme o seu endereço de e-mail",
            EMAIL_ADDRESS: {
                LABEL: "Endereço de E-mail",
                ISSUE: {
                    INVALID: "Endereço de e-mail inválido"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Pesquisa de ingressos",
            SUBTITLE: "Digite o número do tíquete e o endereço de e-mail",
            TICKET_NUMBER: {
                LABEL: "Número do ticket",
                ISSUE: {
                    INVALID: "Número do ticket inválido"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Endereço de E-mail",
                ISSUE: {
                    INVALID: "Endereço de e-mail inválido"
                }
            },
            ISSUE: {
                NOT_FOUND: "Ticket não encontrado",
                ERROR: "Erro"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Página de Confirmação para Autorização de Devolução de Mercadoria",
            SUBTITLE: "Preencha o formulário abaixo para iniciar sua devolução.",
            PERSONAL_INFORMATION: {
                TITLE: "Informações pessoais",
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Sobrenome"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Endereço de E-mail"
                },
                PHONE_NUMBER: {
                    LABEL: "Número de telefone"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Endereço de substituição",
                TITLE: "Endereço",
                COUNTRY: {
                    LABEL: "País"
                },
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Sobrenome"
                },
                ADDRESS_1: {
                    LABEL: "Endereço"
                },
                ADDRESS_2: {
                    LABEL: "Apartamento, suíte, etc. (opcional)"
                },
                CITY: {
                    LABEL: "Cidade"
                },
                PROVINCE: {
                    LABEL: "Província"
                },
                POSTAL_CODE: {
                    LABEL: "Código Postal"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "O endereço de devolução é o mesmo"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Endereço da devolução",
                COUNTRY: {
                    LABEL: "País"
                },
                FIRST_NAME: {
                    LABEL: "Nome"
                },
                LAST_NAME: {
                    LABEL: "Sobrenome"
                },
                ADDRESS_1: {
                    LABEL: "Endereço"
                },
                ADDRESS_2: {
                    LABEL: "Apartamento, suíte, etc. (opcional)"
                },
                CITY: {
                    LABEL: "Cidade"
                },
                PROVINCE: {
                    LABEL: "Província"
                },
                POSTAL_CODE: {
                    LABEL: "Código Postal"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Pedido",
                REQUEST_TYPE: {
                    LABEL: "Tipo de pedido"
                },
                RETURN_ITEMS: {
                    TITLE: "Itens que você está devolvendo"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Itens que você está recebendo"
                }
            },
            CONFIRMATION: {
                TITLE: "Confirmação",
                CUSTOMER_MESSAGE: {
                    TITLE: "Prezado Cliente",
                    STEPS: "1. Revise e verifique as informações do seu pedido.\r\n2. Revise e verifique seu endereço.\r\n3. Concorde com o pedido clicando na caixa de seleção abaixo.\r\n4. Envie o pedido clicando no botão ENVIAR abaixo.",
                    FOOTER: "Caso tenha alguma dúvida sobre o seu pedido ou precise de mais assistência, por favor, visite AJUDA.KOBO.COM para outras opções de contato e ferramentas de suporte."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Concordo em retornar e receber os itens indicados nesta requisição."
                }
            }
        },
        TICKET: {
            TITLE: "Autorização de devolução de mercadoria",
            GENERAL_INFORMATION: {
                TITLE: "Informações gerais",
                UPDATE_ADDRESS: "Atualizar endereço",
                PERSONAL_INFORMATION: {
                    TITLE: "Pessoal"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Endereço de substituição",
                    TITLE: "Endereço",
                    TITLE_SAME: "Endereço"
                },
                RETURN_ADDRESS: {
                    TITLE: "Endereço da devolução",
                    SAME_AS_REPLACEMENT_ADDRESS: "Mesmo que o endereço de substituição"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Pedido",
                REQUEST_TYPE: {
                    LABEL: "Tipo de pedido"
                },
                RETURN_ITEMS: {
                    TITLE: "Itens que você está devolvendo"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Itens que você está recebendo"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informações de rastreamento da devolução"
                        LABEL: "Pacote de rastreamento"
                    },
                    OUTBOUND: {
                        //LABEL: "Informações de rastreamento de substituição"
                        LABEL: "Pacote de rastreamento"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up bloqueado. Permita pop-ups para este site ou abra o rastreamento ",
                    POPUP_BLOCKED_LINK_LABEL: "aqui"
                },
                DOWNLOAD_RETURN_LABEL: "Baixar Return Label",
                RETURN_LABEL_PENDING: "Etiqueta de devolução pendente",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "O pedido de RMA foi recebido.\r\nAs etiquetas de devolução serão criadas em breve.\r\nAssim que as etiquetas forem criadas, você receberá um e-mail contendo as instruções de devolução.\r\nVocê também poderá baixar as etiquetas de devolução nesta página.",
                            RETURN_SHIPPED:
                                "Os itens devolvidos foram enviados.\r\nAguarde alguns dias úteis para que os itens cheguem ao nosso armazém.\r\nObservação: o depósito precisa de alguns dias úteis para processar o pedido após a chegada dos itens ao depósito.",
                            RETURN_RECEIVED:
                                "Os itens devolvidos foram processados pelo armazém.\r\nOs itens de reposição serão enviados em alguns dias úteis.",
                            SHIPMENT_SHIPPED: "Os itens de reposição foram enviados.\r\nVeja as informações de rastreamento abaixo.",
                            SHIPMENT_DELIVERED: "Os itens de reposição foram entregues.."
                        },
                        REFUND: {
                            CREATED:
                                "O pedido de RMA foi recebido.\r\nAs etiquetas de devolução serão criadas em breve.\r\nAssim que as etiquetas forem criadas, você receberá um e-mail contendo as instruções de devolução.\r\nVocê também poderá baixar as etiquetas de devolução nesta página.",
                            RETURN_SHIPPED:
                                "Os itens devolvidos foram enviados.\r\nAguarde alguns dias úteis para que os itens cheguem ao nosso armazém.\r\nObservação: o depósito precisa de alguns dias úteis para processar o pedido após a chegada dos itens ao depósito.",
                            RETURN_RECEIVED:
                                "Os itens devolvidos foram processados pelo armazém.\r\nOs itens de reposição serão enviados em alguns dias úteis.",
                            REFUNDED: "O reembolso foi emitido."
                        },
                        SHIP_ONLY: {
                            CREATED: "O pedido de RMA foi recebido.\r\nOs itens de substituição serão enviados dentro de alguns dias úteis.",
                            SHIPMENT_SHIPPED: "Os itens de reposição foram enviados.\r\nVeja as informações de rastreamento abaixo.",
                            SHIPMENT_DELIVERED: "Os itens de reposição foram entregues.."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "O pedido de RMA foi recebido.\r\nAs etiquetas de devolução serão criadas em breve.\r\nAssim que as etiquetas forem criadas, você receberá um e-mail contendo as instruções de devolução.\r\nVocê também poderá baixar as etiquetas de devolução nesta página.",
                            RETURN_SHIPPED:
                                "Os itens devolvidos foram enviados.\r\nAguarde alguns dias úteis para que os itens cheguem ao nosso armazém.\r\nObservação: o depósito precisa de alguns dias úteis para processar o pedido após a chegada dos itens ao depósito.",
                            RETURN_RECEIVED: "Os itens devolvidos foram processados pelo armazém."
                        }
                    },
                    CREATED: {
                        TITLE: "Criado",
                        DESCRIPTION: "O pedido de RMA foi criado."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Aviso de Verificação de Endereço Enviado",
                        DESCRIPTION: "O e-mail de verificação de endereço foi enviado para seu endereço de e-mail."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Endereço verificado",
                        DESCRIPTION: "O endereço foi verificado.."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Criação de etiqueta de devolução",
                        DESCRIPTION: "As etiquetas de devolução foram criadas."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Aviso de devolução enviado",
                    //     DESCRIPTION: "Etiquetas de devolução e instruções foram enviadas para seu endereço de e-mail."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Aviso de devolução final enviado",
                    //     DESCRIPTION: "Foi enviado um lembrete de devolução para o seu endereço de e-mail."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Devolução Enviada",
                        DESCRIPTION: "A devolução foi enviada."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Devolução recebida",
                        DESCRIPTION: "O armazém recebeu os itens de devolução."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Aviso de devolução recebido enviado",
                    //     DESCRIPTION: "O armazém recebeu a devolução.."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Remessa criada",
                        DESCRIPTION: "O armazém preparou a remessa."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Remessa enviada",
                        DESCRIPTION: "O armazém enviou os itens de substituição."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Notificação de remessa enviada",
                    //     DESCRIPTION: "Notificação de remessa enviada"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Remessa Entregue",
                        DESCRIPTION: "A remessa foi entregue."
                    },
                    REFUNDED: {
                        TITLE: "Reembolsado",
                        DESCRIPTION: "O reembolso foi emitido."
                    },
                    CANCELLED: {
                        TITLE: "Cancelado",
                        DESCRIPTION: "O pedido de RMA foi encerrado."
                    },
                    CLOSED: {
                        TITLE: "Fechado",
                        DESCRIPTION: "O pedido de RMA foi encerrado."
                    },
                    REACHED: "Status Alcançado",
                    UNREACHED: "Status Não Alcançado"
                },
                TIMELINE: {
                    TITLE: "Linha do Tempo do Pedido"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Tickets Relacionados",
                TICKET_NUMBER: "Número do ticket",
                CREATED_DATE: "Data de criação",
                REQUEST_TYPES: "Tipos de pedido",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Item",
            ORDER_REFERENCE: {
                LABEL: "Referência do pedido"
            },
            RETURN_REASON: {
                LABEL: "Motivo da devolução"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Motivo da devolução Descrição"
            },
            CONDITION: {
                LABEL: "Condição",
                VALUE: {
                    NEW: "Novo",
                    REFURBISHED: "Recondicionado"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Referência do pedido",
            RETURN_REASON: "Motivo da devolução",
            RETURN_REASON_DESCRIPTION: "Motivo da devolução Descrição",
            CONDITION: {
                LABEL: "Condição",
                VALUE: {
                    NEW: "Novo",
                    REFURBISHED: "Recondicionado"
                }
            },
            TYPE: {
                RETURN: "Devolver",
                REPLACEMENT: "Substituição"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "SUBMETER"
            },
            CANCEL: {
                LABEL: "CANCELAR"
            },
            SEARCH: {
                LABEL: "PESQUISAR"
            },
            CLOSE: {
                LABEL: "FECHAR"
            },
            HELP: {
                LABEL: "AJUDA"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Substituição",
            REFUND: "Reembolso",
            RETURN_ONLY: "Somente devolução",
            SHIP_ONLY: "Somente Envio"
        }
    },
    NL: {
        AUTHENTICATION: {
            TITLE: "Bevestig je e-mailadres",
            EMAIL_ADDRESS: {
                LABEL: "E-mailadres",
                ISSUE: {
                    INVALID: "Ongeldig e-mailadres"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Ticket zoeken",
            SUBTITLE: "Voer het ticketnummer en e-mailadres in",
            TICKET_NUMBER: {
                LABEL: "Ticketnummer",
                ISSUE: {
                    INVALID: "Ongeldig ticketnummer"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "E-mailadres",
                ISSUE: {
                    INVALID: "Ongeldig e-mailadres"
                }
            },
            ISSUE: {
                NOT_FOUND: "Ticket niet gevonden",
                ERROR: "Fout"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Bevestigingspagina voor Return Merchandise Authorization",
            SUBTITLE: "Vul het onderstaande formulier in om je retour te starten.",
            PERSONAL_INFORMATION: {
                TITLE: "Persoonlijke gegevens",
                FIRST_NAME: {
                    LABEL: "Voornaam"
                },
                LAST_NAME: {
                    LABEL: "Achternaam"
                },
                EMAIL_ADDRESS: {
                    LABEL: "E-mailadres"
                },
                PHONE_NUMBER: {
                    LABEL: "Telefoonnummer"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Adres vervanging",
                TITLE: "Adres",
                COUNTRY: {
                    LABEL: "Land"
                },
                FIRST_NAME: {
                    LABEL: "Voornaam"
                },
                LAST_NAME: {
                    LABEL: "Achternaam"
                },
                ADDRESS_1: {
                    LABEL: "Adres"
                },
                ADDRESS_2: {
                    LABEL: "Appartement, suite, etc. (optioneel)"
                },
                CITY: {
                    LABEL: "Stad"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Postcode"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Retouradres is hetzelfde"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Retouradres",
                COUNTRY: {
                    LABEL: "Land"
                },
                FIRST_NAME: {
                    LABEL: "Voornaam"
                },
                LAST_NAME: {
                    LABEL: "Achternaam"
                },
                ADDRESS_1: {
                    LABEL: "Adres"
                },
                ADDRESS_2: {
                    LABEL: "Appartement, suite, etc. (optioneel)"
                },
                CITY: {
                    LABEL: "Stad"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Postcode"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Aanvraag",
                REQUEST_TYPE: {
                    LABEL: "Aanvraagtype"
                },
                RETURN_ITEMS: {
                    TITLE: "Artikelen die je retourneert"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artikelen die je ontvangt"
                }
            },
            CONFIRMATION: {
                TITLE: "Bevestiging",
                CUSTOMER_MESSAGE: {
                    TITLE: "Beste klant,",
                    STEPS: "1. Controleer en verifieer de gegevens van je aanvraag.\r\n2. Controleer en verifieer je adres.\r\n3. Ga akkoord met de aanvraag door op het selectievakje hieronder te klikken.\r\n4. Dien de aanvraag in door op de knop VERZENDEN hieronder te klikken.",
                    FOOTER: "Mocht je vragen hebben over je aanvraag of ergens anders hulp bij nodig hebben, ga dan naar HELP.KOBO.COM voor meer contactmogelijkheden en ondersteunende tools."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Ik ga akkoord met het retourneren en ontvangen van de artikelen die in deze aanvraag worden vermeld."
                }
            }
        },
        TICKET: {
            TITLE: "Return Merchandise Authorization",
            GENERAL_INFORMATION: {
                TITLE: "Algemene informatie",
                UPDATE_ADDRESS: "Adres bijwerken",
                PERSONAL_INFORMATION: {
                    TITLE: "Persoonlijk"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Adres vervanging",
                    TITLE: "Adres",
                    TITLE_SAME: "Adres"
                },
                RETURN_ADDRESS: {
                    TITLE: "Retouradres",
                    SAME_AS_REPLACEMENT_ADDRESS: "Hetzelfde als adres vervanging"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Aanvraag",
                REQUEST_TYPE: {
                    LABEL: "Aanvraagtype"
                },
                RETURN_ITEMS: {
                    TITLE: "Artikelen die je retourneert"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Artikelen die je ontvangt"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Volginformatie retour"
                        LABEL: "Volg pakket"
                    },
                    OUTBOUND: {
                        //LABEL: "Informatie over het volgen van de vervanging"
                        LABEL: "Volg pakket"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up geblokkeerd. Sta pop-ups toe voor deze site of open de tracking ",
                    POPUP_BLOCKED_LINK_LABEL: "hier"
                },
                DOWNLOAD_RETURN_LABEL: "Retourlabel downloaden",
                RETURN_LABEL_PENDING: "Retourlabel in aanstond",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Het RMA-verzoek is ontvangen.\r\nDe retourlabels worden binnenkort aangemaakt.\r\nZodra de labels zijn aangemaakt, ontvang je een e-mail met retourinstructies.\r\nJe kunt op deze pagina ook de retourlabels downloaden.",
                            RETURN_SHIPPED:
                                "De geretourneerde artikelen zijn verzonden.\r\nHoud er rekening mee dat het een paar werkdagen kan duren voordat de artikelen in ons magazijn aankomen.\r\nLet op: het magazijn heeft een paar werkdagen nodig om de aanvraag te verwerken nadat de artikelen in het magazijn zijn aangekomen.",
                            RETURN_RECEIVED:
                                "De geretourneerde artikelen zijn verwerkt door het magazijn.\r\nDe vervangende artikelen worden binnen enkele werkdagen verzonden.",
                            SHIPMENT_SHIPPED: "De vervangende artikelen zijn verzonden.\r\nHieronder vind je informatie om je bestelling te volgen.",
                            SHIPMENT_DELIVERED: "De vervangende artikelen zijn geleverd."
                        },
                        REFUND: {
                            CREATED:
                                "Het RMA-verzoek is ontvangen.\r\nDe retourlabels worden binnenkort aangemaakt.\r\nZodra de labels zijn aangemaakt, ontvang je een e-mail met retourinstructies.\r\nJe kunt op deze pagina ook de retourlabels downloaden.",
                            RETURN_SHIPPED:
                                "De geretourneerde artikelen zijn verzonden.\r\nHoud er rekening mee dat het een paar werkdagen kan duren voordat de artikelen in ons magazijn aankomen.\r\nLet op: het magazijn heeft een paar werkdagen nodig om de aanvraag te verwerken nadat de artikelen in het magazijn zijn aangekomen.",
                            RETURN_RECEIVED:
                                "De geretourneerde artikelen zijn verwerkt door het magazijn.\r\nDe vervangende artikelen worden binnen enkele werkdagen verzonden.",
                            REFUNDED: "De terugbetaling is uitgevoerd.."
                        },
                        SHIP_ONLY: {
                            CREATED: "Het RMA-verzoek is ontvangen.\r\nVervangende artikelen worden binnen enkele werkdagen verzonden.",
                            SHIPMENT_SHIPPED: "De vervangende artikelen zijn verzonden.\r\nHieronder vind je informatie om je bestelling te volgen.",
                            SHIPMENT_DELIVERED: "De vervangende artikelen zijn geleverd."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Het RMA-verzoek is ontvangen.\r\nDe retourlabels worden binnenkort aangemaakt.\r\nZodra de labels zijn aangemaakt, ontvang je een e-mail met retourinstructies.\r\nJe kunt op deze pagina ook de retourlabels downloaden.",
                            RETURN_SHIPPED:
                                "De geretourneerde artikelen zijn verzonden.\r\nHoud er rekening mee dat het een paar werkdagen kan duren voordat de artikelen in ons magazijn aankomen.\r\nLet op: het magazijn heeft een paar werkdagen nodig om de aanvraag te verwerken nadat de artikelen in het magazijn zijn aangekomen.",
                            RETURN_RECEIVED: "De geretourneerde artikelen zijn verwerkt door het magazijn."
                        }
                    },
                    CREATED: {
                        TITLE: "Aangemaakt",
                        DESCRIPTION: "Er is een RMA-verzoek aangemaakt."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Kennisgeving adresverificatie verzonden",
                        DESCRIPTION: "De e-mail voor de adresverificatie is naar je e-mailadres verzonden."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Adres geverifieerd",
                        DESCRIPTION: "Het adres is geverifieerd."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Retourlabel aangemaakt",
                        DESCRIPTION: "De retourlabels zijn aangemaakt."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Kennisgeving retour verzonden",
                    //     DESCRIPTION: "De retourlabels en -instructies zijn naar je e-mailadres gestuurd."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Laatste kennisgeving retour verzonden",
                    //     DESCRIPTION: "Er is een herinnering voor de retour verzonden naar je e-mailadres."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Retour verzonden",
                        DESCRIPTION: "Retour is verzonden."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Retour ontvangen",
                        DESCRIPTION: "De geretourneerde artikelen zijn ontvangen door het magazijn."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Kennisgeving retour ontvangen verzonden",
                    //     DESCRIPTION: "De retour is ontvangen door het magazijn."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Verzending aangemaakt",
                        DESCRIPTION: "De zending is voorbereid door het magazijn."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Verzending verzonden",
                        DESCRIPTION: "De vervangende artikelen zijn verzonden door het magazijn."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Kennisgeving zending verzonden verzonden",
                    //     DESCRIPTION: "Kennisgeving zending verzonden verzonden"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Verzending bezorgd",
                        DESCRIPTION: "De verzending is geleverd."
                    },
                    REFUNDED: {
                        TITLE: "Terugbetaald",
                        DESCRIPTION: "De terugbetaling is verzonden."
                    },
                    CANCELLED: {
                        TITLE: "Geannuleerd",
                        DESCRIPTION: "Het RMA-verzoek is gesloten."
                    },
                    CLOSED: {
                        TITLE: "Gesloten",
                        DESCRIPTION: "Het RMA-verzoek is gesloten."
                    },
                    REACHED: "Status Bereikt",
                    UNREACHED: "Status Niet Bereikt"
                },
                TIMELINE: {
                    TITLE: "Tijdlijn aanvraag"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Gerelateerde Tickets",
                TICKET_NUMBER: "Ticketnummer",
                CREATED_DATE: "Aanmaakdatum",
                REQUEST_TYPES: "Aanvraagtypes",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Artikel",
            ORDER_REFERENCE: {
                LABEL: "Bestelreferentie"
            },
            RETURN_REASON: {
                LABEL: "Reden retour"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Beschrijving reden retour"
            },
            CONDITION: {
                LABEL: "Conditie",
                VALUE: {
                    NEW: "Nieuw",
                    REFURBISHED: "Gereviseerd"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Bestelreferentie",
            RETURN_REASON: "Reden retour",
            RETURN_REASON_DESCRIPTION: "Beschrijving reden retour",
            CONDITION: {
                LABEL: "Conditie",
                VALUE: {
                    NEW: "Nieuw",
                    REFURBISHED: "Gereviseerd"
                }
            },
            TYPE: {
                RETURN: "Retourneren",
                REPLACEMENT: "Vervanging"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "VERZENDEN"
            },
            CANCEL: {
                LABEL: "ANNULEREN"
            },
            SEARCH: {
                LABEL: "ZOEKEN"
            },
            CLOSE: {
                LABEL: "SLUITEN"
            },
            HELP: {
                LABEL: "HULP"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Vervanging",
            REFUND: "Terugbetaling",
            RETURN_ONLY: "Alleen retourneren",
            SHIP_ONLY: "Alleen verzenden"
        }
    },
    CS: {
        AUTHENTICATION: {
            TITLE: "Potvrďte svou e-mailovou adresu",
            EMAIL_ADDRESS: {
                LABEL: "E-mailová adresa",
                ISSUE: {
                    INVALID: "Neplatná e-mailová adresa"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Vyhledávání tiketů",
            SUBTITLE: "Zadejte číslo tiketu a e-mailovou adresu",
            TICKET_NUMBER: {
                LABEL: "Číslo tiketu",
                ISSUE: {
                    INVALID: "Neplatné číslo tiketu"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "E-mailová adresa",
                ISSUE: {
                    INVALID: "Neplatná e-mailová adresa"
                }
            },
            ISSUE: {
                NOT_FOUND: "Tiket nenalezen",
                ERROR: "Chyba"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Stránka s potvrzením pro autorizaci vrácení zboží",
            SUBTITLE: "Pokud chcete zahájit vracení zboží, vyplňte formulář níže.",
            PERSONAL_INFORMATION: {
                TITLE: "Osobní údaje",
                FIRST_NAME: {
                    LABEL: "Jméno"
                },
                LAST_NAME: {
                    LABEL: "Příjmení"
                },
                EMAIL_ADDRESS: {
                    LABEL: "E-mailová adresa"
                },
                PHONE_NUMBER: {
                    LABEL: "Telefonní číslo"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Adresa pro zaslání náhradního zboží",
                TITLE: "Adresa",
                COUNTRY: {
                    LABEL: "Země"
                },
                FIRST_NAME: {
                    LABEL: "Jméno"
                },
                LAST_NAME: {
                    LABEL: "Příjmení"
                },
                ADDRESS_1: {
                    LABEL: "Adresa"
                },
                ADDRESS_2: {
                    LABEL: "Číslo bytu atd. (nepovinné)"
                },
                CITY: {
                    LABEL: "Město"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Poštovní směrovací číslo"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Adresa pro vrácení je stejná"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Adresa pro vrácení",
                COUNTRY: {
                    LABEL: "Země"
                },
                FIRST_NAME: {
                    LABEL: "Jméno"
                },
                LAST_NAME: {
                    LABEL: "Příjmení"
                },
                ADDRESS_1: {
                    LABEL: "Adresa"
                },
                ADDRESS_2: {
                    LABEL: "Číslo bytu atd. (nepovinné)"
                },
                CITY: {
                    LABEL: "Město"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Poštovní směrovací číslo"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Žádost",
                REQUEST_TYPE: {
                    LABEL: "Typ žádosti"
                },
                RETURN_ITEMS: {
                    TITLE: "Produkty, které vracíte"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Produkty, které obdržíte"
                }
            },
            CONFIRMATION: {
                TITLE: "Potvrzení",
                CUSTOMER_MESSAGE: {
                    TITLE: "Vážený zákazníku",
                    STEPS: "1. Zkontrolujte a ověřte informace o své žádosti.\r\n2. Zkontrolujte a ověřte adresu.\r\n3. Souhlas s žádostí vyjádříte kliknutím na zaškrtávací políčko níže.\r\n4. Odešlete žádost kliknutím na tlačítko ODESLAT níže.",
                    FOOTER: "Pokud máte jakékoli dotazy týkající se vaší žádosti nebo potřebujete další pomoc, navštivte HELP.KOBO.COM, kde najdete další kontaktní údaje a nástroje podpory."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Souhlasím s vrácením a převzetím produktů uvedených v této žádosti."
                }
            }
        },
        TICKET: {
            TITLE: "Autorizace vrácení zboží",
            GENERAL_INFORMATION: {
                TITLE: "Obecné informace",
                UPDATE_ADDRESS: "Aktualizovat adresu",
                PERSONAL_INFORMATION: {
                    TITLE: "Osobní"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Adresa pro zaslání náhradního zboží",
                    TITLE: "Adresa",
                    TITLE_SAME: "Adresa"
                },
                RETURN_ADDRESS: {
                    TITLE: "Adresa pro vrácení",
                    SAME_AS_REPLACEMENT_ADDRESS: "Stejná jako adresa pro zaslání náhradního zboží"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Žádost",
                REQUEST_TYPE: {
                    LABEL: "Typ žádosti"
                },
                RETURN_ITEMS: {
                    TITLE: "Produkty, které vracíte"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Produkty, které obdržíte"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informace o sledování vraceného zboží"
                        LABEL: "Sledovat balíček"
                    },
                    OUTBOUND: {
                        //LABEL: "Informace o sledování náhradního zboží"
                        LABEL: "Sledovat balíček"
                    },
                    POPUP_BLOCKED_PREFIX: "Vyskakovaci okno bylo zablokovano. Povolte pro tento web vyskakovaci okna nebo otevrete sledovani ",
                    POPUP_BLOCKED_LINK_LABEL: "zde"
                },
                DOWNLOAD_RETURN_LABEL: "Stáhnout štítek pro vrácení",
                RETURN_LABEL_PENDING: "Návratový štítek čeká na vyřízení",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Žádost o RMA byla přijata.\r\nV nejbližší době budou vytvořeny štítky pro vrácení zboží.\r\nPo vytvoření štítků obdržíte e-mail s pokyny pro vrácení.\r\nNa této stránce si také budete moct stáhnout štítky pro vrácení zboží.",
                            RETURN_SHIPPED:
                                "Vrácené zboží bylo odesláno.\r\nPočkejte několik pracovních dnů, než zboží dorazí do našeho skladu.\r\nUpozornění: sklad potřebuje několik pracovních dnů na zpracování žádosti poté, co zboží dorazí do skladu.",
                            RETURN_RECEIVED: "Vrácené zboží bylo zpracováno skladem.\r\nNáhradní zboží bude odesláno do několika pracovních dnů.",
                            SHIPMENT_SHIPPED: "Náhradní zboží bylo odesláno.\r\nInformace o sledování naleznete níže.",
                            SHIPMENT_DELIVERED: "ReplacNáhradní zboží bylo doručeno."
                        },
                        REFUND: {
                            CREATED:
                                "Žádost o RMA byla přijata.\r\nV nejbližší době budou vytvořeny štítky pro vrácení zboží.\r\nPo vytvoření štítků obdržíte e-mail s pokyny pro vrácení.\r\nNa této stránce si také budete moct stáhnout štítky pro vrácení zboží.",
                            RETURN_SHIPPED:
                                "Vrácené zboží bylo odesláno.\r\nPočkejte několik pracovních dnů, než zboží dorazí do našeho skladu.\r\nUpozornění: sklad potřebuje několik pracovních dnů na zpracování žádosti poté, co zboží dorazí do skladu.",
                            RETURN_RECEIVED: "Vrácené zboží bylo zpracováno skladem.\r\nNáhradní zboží bude odesláno do několika pracovních dnů.",
                            REFUNDED: "Peníze byly vráceny."
                        },
                        SHIP_ONLY: {
                            CREATED: "Žádost o RMA byla přijata.\r\nNáhradní zboží bude odesláno během několika pracovních dnů.",
                            SHIPMENT_SHIPPED: "Náhradní zboží bylo odesláno.\r\nInformace o sledování naleznete níže.",
                            SHIPMENT_DELIVERED: "Náhradní zboží bylo doručeno."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Žádost o RMA byla přijata.\r\nV nejbližší době budou vytvořeny štítky pro vrácení zboží.\r\nPo vytvoření štítků obdržíte e-mail s pokyny pro vrácení.\r\nNa této stránce si také budete moct stáhnout štítky pro vrácení zboží.",
                            RETURN_SHIPPED:
                                "Vrácené zboží bylo odesláno.\r\nPočkejte několik pracovních dnů, než zboží dorazí do našeho skladu.\r\nUpozornění: sklad potřebuje několik pracovních dnů na zpracování žádosti poté, co zboží dorazí do skladu.",
                            RETURN_RECEIVED: "Vrácené zboží bylo zpracováno skladem."
                        }
                    },
                    CREATED: {
                        TITLE: "Vytvořeno",
                        DESCRIPTION: "Žádost RMA byla vytvořena."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Oznámení o ověření adresy odesláno",
                        DESCRIPTION: "Na vaši e-mailovou adresu byl odeslán ověřovací e-mail."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Adresa ověřena",
                        DESCRIPTION: "Adresa byla ověřena."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Štítek pro vrácení byl vytvořen",
                        DESCRIPTION: "Štítky pro vrácení byly vytvořeny."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Oznámení o vrácení odesláno",
                    //     DESCRIPTION: "Na vaši e-mailovou adresu byly zaslány štítky a pokyny pro vrácení zboží."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Konečné oznámení o vrácení odesláno",
                    //     DESCRIPTION: "Připomenutí vrácení bylo zasláno na vaši e-mailovou adresu."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Vrácené zboží odesláno",
                        DESCRIPTION: "Vrácené zboží bylo odesláno."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Vrácené zboží přijato",
                        DESCRIPTION: "Sklad obdržel vrácené zboží."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Oznámení o přijetí vráceného zboží odesláno",
                    //     DESCRIPTION: "Sklad obdržel vrácené zboží."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Zásilka vytvořena",
                        DESCRIPTION: "Sklad připravil zásilku."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Zásilka odeslána",
                        DESCRIPTION: "Sklad odeslal náhradní zboží."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Oznámení o odeslání zásilky odesláno",
                    //     DESCRIPTION: "Oznámení o odeslání zásilky odesláno."
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Zásilka doručena",
                        DESCRIPTION: "Zásilka byla doručena."
                    },
                    REFUNDED: {
                        TITLE: "Peníze vráceny",
                        DESCRIPTION: "Peníze byly vráceny."
                    },
                    CANCELLED: {
                        TITLE: "Zrušeno",
                        DESCRIPTION: "Žádost o RMA byla uzavřena."
                    },
                    CLOSED: {
                        TITLE: "Uzavřeno",
                        DESCRIPTION: "Žádost o RMA byla uzavřena."
                    },
                    REACHED: "Stav Dosažen",
                    UNREACHED: "Stav Nedosažen"
                },
                TIMELINE: {
                    TITLE: "Časová osa žádosti"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Související tikety",
                TICKET_NUMBER: "Číslo tiketu",
                CREATED_DATE: "Datum vytvoření",
                REQUEST_TYPES: "Typy žádostí",
                STATUS: "Stav"
            }
        },
        ITEM: {
            LABEL: "Produkt",
            ORDER_REFERENCE: {
                LABEL: "Ref. číslo objednávky"
            },
            RETURN_REASON: {
                LABEL: "Důvod vrácení"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Popis důvodu vrácení"
            },
            CONDITION: {
                LABEL: "Stav",
                VALUE: {
                    NEW: "Nový",
                    REFURBISHED: "Repasovaný"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Ref. číslo objednávky",
            RETURN_REASON: "Důvod vrácení",
            RETURN_REASON_DESCRIPTION: "Popis důvodu vrácení",
            CONDITION: {
                LABEL: "Stav",
                VALUE: {
                    NEW: "Nový",
                    REFURBISHED: "Repasovaný"
                }
            },
            TYPE: {
                RETURN: "Pro vrácení",
                REPLACEMENT: "Náhradní zboží"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "ODESLAT"
            },
            CANCEL: {
                LABEL: "ZRUŠIT"
            },
            SEARCH: {
                LABEL: "HLEDAT"
            },
            CLOSE: {
                LABEL: "ZAVŘÍT"
            },
            HELP: {
                LABEL: "POMOC"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Náhradní zboží",
            REFUND: "Vrácení peněz",
            RETURN_ONLY: "Pouze vrácení",
            SHIP_ONLY: "Pouze pro odeslání"
        }
    },
    PL: {
        AUTHENTICATION: {
            TITLE: "Potwierdź swój adres e-mail",
            EMAIL_ADDRESS: {
                LABEL: "Adres e-mail",
                ISSUE: {
                    INVALID: "Nieprawidłowy adres e-mail"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Wyszukiwanie zgłoszeń",
            SUBTITLE: "Wprowadź numer zgłoszenia i adres e-mail",
            TICKET_NUMBER: {
                LABEL: "Numer zgłoszenia",
                ISSUE: {
                    INVALID: "Nieprawidłowy numer zgłoszenia"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Adres e-mail",
                ISSUE: {
                    INVALID: "Nieprawidłowy adres e-mail"
                }
            },
            ISSUE: {
                NOT_FOUND: "Nie znaleziono zgłoszenia",
                ERROR: "Błąd"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Strona potwierdzenia autoryzacji zwrotu towaru",
            SUBTITLE: "Wypełnij poniższy formularz, aby rozpocząć zwrot.",
            PERSONAL_INFORMATION: {
                TITLE: "Dane osobowe",
                FIRST_NAME: {
                    LABEL: "Imię"
                },
                LAST_NAME: {
                    LABEL: "Nazwisko"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Adres e-mail"
                },
                PHONE_NUMBER: {
                    LABEL: "Numer telefonu"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Adres zastępczy",
                TITLE: "Adres",
                COUNTRY: {
                    LABEL: "Kraj"
                },
                FIRST_NAME: {
                    LABEL: "Imię"
                },
                LAST_NAME: {
                    LABEL: "Nazwisko"
                },
                ADDRESS_1: {
                    LABEL: "Adres"
                },
                ADDRESS_2: {
                    LABEL: "Mieszkanie, apartament itp. (opcjonalnie)"
                },
                CITY: {
                    LABEL: "Miasto"
                },
                PROVINCE: {
                    LABEL: "Województwo"
                },
                POSTAL_CODE: {
                    LABEL: "Kod pocztowy"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Adres zwrotny jest taki sam"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Adres zwrotny",
                COUNTRY: {
                    LABEL: "Kraj"
                },
                FIRST_NAME: {
                    LABEL: "First name"
                },
                LAST_NAME: {
                    LABEL: "Last name"
                },
                ADDRESS_1: {
                    LABEL: "Adres"
                },
                ADDRESS_2: {
                    LABEL: "Mieszkanie, apartament itp. (opcjonalnie)"
                },
                CITY: {
                    LABEL: "Miasto"
                },
                PROVINCE: {
                    LABEL: "Województwo"
                },
                POSTAL_CODE: {
                    LABEL: "Kod pocztowy"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Zgłoszenie",
                REQUEST_TYPE: {
                    LABEL: "Typ zgłoszenia"
                },
                RETURN_ITEMS: {
                    TITLE: "Pozycje, które zwracasz"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Pozycje, które otrzymasz"
                }
            },
            CONFIRMATION: {
                TITLE: "Potwierdzenie",
                CUSTOMER_MESSAGE: {
                    TITLE: "Szanowny Kliencie",
                    STEPS: "1. Przejrzyj i zweryfikuj informacje dotyczące wniosku.\r\n2. Sprawdź i zweryfikuj swój adres.\r\n3. Zaakceptuj wniosek, klikając poniższe pole wyboru.\r\n4. Prześlij wniosek, klikając przycisk PRZEŚLIJ poniżej.",
                    FOOTER: "Jeśli masz jakiekolwiek pytania dotyczące swojego wniosku lub potrzebujesz dalszej pomocy, odwiedź HELP.KOBO.COM, aby uzyskać inne opcje kontaktu i narzędzia wsparcia."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Wyrażam zgodę na zwrot i odbiór pozycji wskazanych w niniejszym wniosku."
                }
            }
        },
        TICKET: {
            TITLE: "Autoryzacja zwrotu towaru",
            GENERAL_INFORMATION: {
                TITLE: "Informacje ogólne",
                UPDATE_ADDRESS: "Zaktualizuj adres",
                PERSONAL_INFORMATION: {
                    TITLE: "Osobiste"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Adres zastępczy",
                    TITLE: "Adres",
                    TITLE_SAME: "Adres"
                },
                RETURN_ADDRESS: {
                    TITLE: "Adres zwrotny",
                    SAME_AS_REPLACEMENT_ADDRESS: "Taki sam jak adres zastępczy"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Zgłoszenie",
                REQUEST_TYPE: {
                    LABEL: "Typ zgłoszenia"
                },
                RETURN_ITEMS: {
                    TITLE: "Pozycje, które zwracasz"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Pozycje, które otrzymasz"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informacje do śledzenia zwrotu"
                        LABEL: "Śledź pakiet"
                    },
                    OUTBOUND: {
                        //LABEL: "Informacje do śledzenia wymiany"
                        LABEL: "Śledź pakiet"
                    },
                    POPUP_BLOCKED_PREFIX: "Wyskakujace okno zostalo zablokowane. Zezwol na wyskakujace okna dla tej witryny lub otworz sledzenie ",
                    POPUP_BLOCKED_LINK_LABEL: "tutaj"
                },
                DOWNLOAD_RETURN_LABEL: "Pobierz etykietę zwrotną",
                RETURN_LABEL_PENDING: "Etykieta zwrotu oczekuje",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Otrzymano zgłoszenie zwrotu.\r\nEtykiety zwrotne zostaną wkrótce utworzone.\r\nPo utworzeniu etykiet otrzymasz wiadomość e-mail zawierającą instrukcje dotyczące zwrotu.\r\nNa tej stronie można również pobrać etykiety zwrotne.",
                            RETURN_SHIPPED:
                                "Wysłano pozycje zwrotu.\r\nProsimy o odczekanie kilku dni roboczych na dotarcie pozycji do naszego magazynu.\r\nUwaga: magazyn potrzebuje kilku dni roboczych na przetworzenie żądania po dostarczeniu pozycji do magazynu.",
                            RETURN_RECEIVED:
                                "Zwrócone pozycje zostały przetworzone przez magazyn.\r\nPozycje zastępcze zostaną wysłane w ciągu kilku dni roboczych.",
                            SHIPMENT_SHIPPED: "Wysłano pozycje zamienne.\r\nPoniżej znajdują się informacje dotyczące śledzenia przesyłki.",
                            SHIPMENT_DELIVERED: "Dostarczono pozycje zamienne."
                        },
                        REFUND: {
                            CREATED:
                                "Otrzymano zgłoszenie zwrotu.\r\nEtykiety zwrotne zostaną wkrótce utworzone.\r\nPo utworzeniu etykiet otrzymasz wiadomość e-mail zawierającą instrukcje dotyczące zwrotu.\r\nNa tej stronie można również pobrać etykiety zwrotne.",
                            RETURN_SHIPPED:
                                "Wysłano pozycje zwrotu.\r\nProsimy o odczekanie kilku dni roboczych na dotarcie pozycji do naszego magazynu.\r\nUwaga: magazyn potrzebuje kilku dni roboczych na przetworzenie żądania po dostarczeniu pozycji do magazynu.",
                            RETURN_RECEIVED:
                                "Zwrócone pozycje zostały przetworzone przez magazyn.\r\nPozycje zastępcze zostaną wysłane w ciągu kilku dni roboczych.",
                            REFUNDED: "Wydano zwrot środków."
                        },
                        SHIP_ONLY: {
                            CREATED: "Otrzymano zgłoszenie zwrotu.\r\nPozycje zastępcze zostaną wysłane w ciągu kilku dni roboczych.",
                            SHIPMENT_SHIPPED: "Wysłano pozycje zamienne.\r\nPoniżej znajdują się informacje dotyczące śledzenia przesyłki.",
                            SHIPMENT_DELIVERED: "Dostarczono pozycje zamienne."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Otrzymano zgłoszenie zwrotu.\r\nEtykiety zwrotne zostaną wkrótce utworzone.\r\nPo utworzeniu etykiet otrzymasz wiadomość e-mail zawierającą instrukcje dotyczące zwrotu.\r\nNa tej stronie można również pobrać etykiety zwrotne.",
                            RETURN_SHIPPED:
                                "Wysłano pozycje zwrotu.\r\nProsimy o odczekanie kilku dni roboczych na dotarcie pozycji do naszego magazynu.\r\nUwaga: magazyn potrzebuje kilku dni roboczych na przetworzenie żądania po dostarczeniu pozycji do magazynu.",
                            RETURN_RECEIVED: "Zwrócone pozycje zostały przetworzone przez magazyn."
                        }
                    },
                    CREATED: {
                        TITLE: "Utworzono",
                        DESCRIPTION: "Utworzono zgłoszenie zwrotu."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Wysłano powiadomienie o weryfikacji adresu",
                        DESCRIPTION: "Wiadomość e-mail z weryfikacją adresu została wysłana na podany adres e-mail."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Zweryfikowano adres",
                        DESCRIPTION: "Adres został zweryfikowany."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Utworzono etykietę zwrotną",
                        DESCRIPTION: "Utworzono etykiety zwrotne."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Wysłano powiadomienie dot. zwrotu",
                    //     DESCRIPTION: "Etykiety zwrotne i instrukcje zostały wysłane na Twój adres e-mail."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Wysłano ostateczne powiadomienie dot. zwrotu",
                    //     DESCRIPTION: "Przypomnienie o zwrocie zostało wysłane na podany adres e-mail."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Wysłano zwrot",
                        DESCRIPTION: "Wysłano zwrot."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Otrzymano zwrot",
                        DESCRIPTION: "Magazyn otrzymał zwrócone pozycje."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Otrzymano ostateczne powiadomienie dot. zwrotu",
                    //     DESCRIPTION: "Magazyn otrzymał zwrot."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Utworzono przesyłkę",
                        DESCRIPTION: "Magazyn przygotował przesyłkę."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Wysłano przesyłkę",
                        DESCRIPTION: "Magazyn wysłał pozycje zastępcze."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Wysłano powiadomienie o wysłaniu przesyłki",
                    //     DESCRIPTION: "Wysłano powiadomienie o wysłaniu przesyłki"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Dostarczono przesyłkę",
                        DESCRIPTION: "Przesyłka została dostarczona."
                    },
                    REFUNDED: {
                        TITLE: "Dokonano zwrotu",
                        DESCRIPTION: "Wydano zwrot środków."
                    },
                    CANCELLED: {
                        TITLE: "Anulowano",
                        DESCRIPTION: "Zamknięto zgłoszenie zwrotu."
                    },
                    CLOSED: {
                        TITLE: "Zamknięto",
                        DESCRIPTION: "Zamknięto zgłoszenie zwrotu."
                    },
                    REACHED: "Status Osiągnięty",
                    UNREACHED: "Status Nieosiągnięty"
                },
                TIMELINE: {
                    TITLE: "Oś czasu zgłoszenia"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Powiązane zgłoszenia",
                TICKET_NUMBER: "Numer zgłoszenia",
                CREATED_DATE: "Data utworzenia",
                REQUEST_TYPES: "Typy zgłoszeń",
                STATUS: "Status"
            }
        },
        ITEM: {
            LABEL: "Przedmiot",
            ORDER_REFERENCE: {
                LABEL: "Numer referencyjny zamówienia"
            },
            RETURN_REASON: {
                LABEL: "Powód zwrotu"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Opis przyczyny zwrotu"
            },
            CONDITION: {
                LABEL: "Warunek",
                VALUE: {
                    NEW: "Nowe",
                    REFURBISHED: "Odnowione"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Numer referencyjny zamówienia",
            RETURN_REASON: "Powód zwrotu",
            RETURN_REASON_DESCRIPTION: "Opis przyczyny zwrotu",
            CONDITION: {
                LABEL: "Warunek",
                VALUE: {
                    NEW: "Nowe",
                    REFURBISHED: "Odnowione"
                }
            },
            TYPE: {
                RETURN: "Powrót",
                REPLACEMENT: "Wymiana"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "PRZEŚLIJ"
            },
            CANCEL: {
                LABEL: "ANULUJ"
            },
            SEARCH: {
                LABEL: "SZUKAJ"
            },
            CLOSE: {
                LABEL: "ZAMKNIJ"
            },
            HELP: {
                LABEL: "POMOC"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Wymiana",
            REFUND: "Zwrot kosztów",
            RETURN_ONLY: "Tylko zwrot",
            SHIP_ONLY: "Tylko wysyłka"
        }
    },
    RO: {
        AUTHENTICATION: {
            TITLE: "Confirmă-ți adresa de e-mail",
            EMAIL_ADDRESS: {
                LABEL: "Adresa de e-mail",
                ISSUE: {
                    INVALID: "Adresă de e-mail nevalidă"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Căutare tichet",
            SUBTITLE: "Completează numărul tichetului și adresa de e-mail",
            TICKET_NUMBER: {
                LABEL: "Număr tichet",
                ISSUE: {
                    INVALID: "Număr de bilet nevalid"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "Adresa de e-mail",
                ISSUE: {
                    INVALID: "Adresă de e-mail nevalidă"
                }
            },
            ISSUE: {
                NOT_FOUND: "Tichetul nu a fost găsit",
                ERROR: "Eroare"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Pagina de confirmare pentru autorizarea returului mărfurilor",
            SUBTITLE: "Completează formularul de mai jos pentru a începe procedura de retur.",
            PERSONAL_INFORMATION: {
                TITLE: "Informații personale",
                FIRST_NAME: {
                    LABEL: "Prenume"
                },
                LAST_NAME: {
                    LABEL: "Numele de familie"
                },
                EMAIL_ADDRESS: {
                    LABEL: "Adresa de e-mail"
                },
                PHONE_NUMBER: {
                    LABEL: "Număr de telefon"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Adresa de înlocuire",
                TITLE: "Adresă",
                COUNTRY: {
                    LABEL: "Țara"
                },
                FIRST_NAME: {
                    LABEL: "Prenume"
                },
                LAST_NAME: {
                    LABEL: "Numele de familie"
                },
                ADDRESS_1: {
                    LABEL: "Adresă"
                },
                ADDRESS_2: {
                    LABEL: "Apartament, scară etc. (opțional)"
                },
                CITY: {
                    LABEL: "Oraș"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Cod poștal"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Adresa de retur este aceeași"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Adresa de retur",
                COUNTRY: {
                    LABEL: "Țara"
                },
                FIRST_NAME: {
                    LABEL: "Prenume"
                },
                LAST_NAME: {
                    LABEL: "Numele de familie"
                },
                ADDRESS_1: {
                    LABEL: "Adresă"
                },
                ADDRESS_2: {
                    LABEL: "Apartament, scară etc. (opțional)"
                },
                CITY: {
                    LABEL: "Oraș"
                },
                PROVINCE: {
                    LABEL: "Provincie"
                },
                POSTAL_CODE: {
                    LABEL: "Cod poștal"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Solicitare",
                REQUEST_TYPE: {
                    LABEL: "Tip de solicitare"
                },
                RETURN_ITEMS: {
                    TITLE: "Articolele pe care le returnezi"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articolele pe care le primești"
                }
            },
            CONFIRMATION: {
                TITLE: "Confirmare",
                CUSTOMER_MESSAGE: {
                    TITLE: "Stimate client,",
                    STEPS: "1. Revizuiește și verifică informațiile solicitate.\r\n2. Revizuiește și verifică adresa ta.\r\n3. Acceptați cererea făcând clic pe caseta de selectare de mai jos.\r\n4. Trimite cererea făcând clic pe butonul TRANSMITE de mai jos.",
                    FOOTER: "Dacă ai întrebări cu privire la solicitarea ta sau ai nevoie de asistență suplimentară, vizitează HELP.KOBO.COM pentru alte opțiuni de contact și instrumente de asistență."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "Sunt de acord să returnez și să primesc articolele indicate în această solicitare."
                }
            }
        },
        TICKET: {
            TITLE: "Autorizație de returnare a mărfurilor",
            GENERAL_INFORMATION: {
                TITLE: "Informații generale",
                UPDATE_ADDRESS: "Actualizează adresa",
                PERSONAL_INFORMATION: {
                    TITLE: "Personal"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Adresa de înlocuire",
                    TITLE: "Adresă",
                    TITLE_SAME: "Adresă"
                },
                RETURN_ADDRESS: {
                    TITLE: "Adresa de retur",
                    SAME_AS_REPLACEMENT_ADDRESS: "Aceeași ca adresa de schimb"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Solicitare",
                REQUEST_TYPE: {
                    LABEL: "Tip de solicitare"
                },
                RETURN_ITEMS: {
                    TITLE: "Articolele pe care le returnezi"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Articolele pe care le primești"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informații de urmărire a returului"
                        LABEL: "Urmăriți pachetul"
                    },
                    OUTBOUND: {
                        //LABEL: "Informații de urmărire a înlocuirii"
                        LABEL: "Urmăriți pachetul"
                    },
                    POPUP_BLOCKED_PREFIX: "Pop-up blocat. Permite pop-up-urile pentru acest site sau deschide urmarirea ",
                    POPUP_BLOCKED_LINK_LABEL: "aici"
                },
                DOWNLOAD_RETURN_LABEL: "Descarcă eticheta de retur",
                RETURN_LABEL_PENDING: "Etichetă de returnare în așteptare",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Solicitarea RMA a fost primită.\r\nEtichetele de returnare vor fi create în scurt timp.\r\nOdată ce etichetele sunt create, vei primi un e-mail care conține instrucțiuni de returnare.\r\nDe asemenea, pe această pagină vei putea descărca etichete de returnare.",
                            RETURN_SHIPPED:
                                "Articolele returnate au fost expediate.\r\nAșteaptă câteva zile lucrătoare pentru ca articolele să ajungă la depozitul nostru.\r\nReține: depozitul are nevoie de câteva zile lucrătoare pentru a prelucra solicitarea după ce articolele ajung la depozit.",
                            RETURN_RECEIVED:
                                "Articolele returnate au fost prelucrate de către depozit.\r\nArticolele de schimb vor fi expediate în câteva zile lucrătoare.",
                            SHIPMENT_SHIPPED: "Articolele de schimb au fost expediate.\r\nConsultă informațiile de urmărire de mai jos.",
                            SHIPMENT_DELIVERED: "Articolele de schimb au fost livrate."
                        },
                        REFUND: {
                            CREATED:
                                "Solicitarea RMA a fost primită.\r\nEtichetele de returnare vor fi create în scurt timp.\r\nOdată ce etichetele sunt create, vei primi un e-mail care conține instrucțiuni de returnare.\r\nDe asemenea, pe această pagină vei putea descărca etichete de returnare.",
                            RETURN_SHIPPED:
                                "Articolele returnate au fost expediate.\r\nAșteaptă câteva zile lucrătoare pentru ca articolele să ajungă la depozitul nostru.\r\nReține: depozitul are nevoie de câteva zile lucrătoare pentru a prelucra solicitarea după ce articolele ajung la depozit.",
                            RETURN_RECEIVED:
                                "Articolele returnate au fost prelucrate de către depozit.\r\nArticolele de schimb vor fi expediate în câteva zile lucrătoare.",
                            REFUNDED: "Rambursarea a fost emisă."
                        },
                        SHIP_ONLY: {
                            CREATED: "Solicitarea RMA a fost primită.\r\nArticolele de schimb vor fi expediate în câteva zile lucrătoare.",
                            SHIPMENT_SHIPPED: "Articolele de schimb au fost expediate.\r\nConsultă informațiile de urmărire de mai jos.",
                            SHIPMENT_DELIVERED: "Articolele de schimb au fost livrate."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Solicitarea RMA a fost primită.\r\nEtichetele de returnare vor fi create în scurt timp.\r\nOdată ce etichetele sunt create, vei primi un e-mail care conține instrucțiuni de returnare.\r\nDe asemenea, pe această pagină vei putea descărca etichete de returnare.",
                            RETURN_SHIPPED:
                                "Articolele returnate au fost expediate.\r\nAșteaptă câteva zile lucrătoare pentru ca articolele să ajungă la depozitul nostru.\r\nReține: depozitul are nevoie de câteva zile lucrătoare pentru a prelucra solicitarea după ce articolele ajung la depozit.",
                            RETURN_RECEIVED: "Articolele returnate au fost prelucrate de către depozit."
                        }
                    },
                    CREATED: {
                        TITLE: "Creat",
                        DESCRIPTION: "Solicitarea RMA a fost creată."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Notificarea de verificare a adresei a fost trimisă",
                        DESCRIPTION: "E-mailul de verificare a adresei a fost trimis la adresa ta de e-mail."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Adresă verificată",
                        DESCRIPTION: "Adresa a fost verificată."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Etichetă de retur creată",
                        DESCRIPTION: "Au fost create etichete de retur."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Notificare de retur trimisă",
                    //     DESCRIPTION: "Etichetele de return și instrucțiunile au fost trimise la adresa ta de e-mail."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Notificarea finală de retur a fost trimisă",
                    //     DESCRIPTION: "Mementoul de retur a fost trimis la adresa ta de e-mail."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Retur expediat",
                        DESCRIPTION: "Returul a fost expediat."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Retur primit",
                        DESCRIPTION: "Depozitul a primit articolele returnate."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Notificarea de primire a returului a fost trimisă",
                    //     DESCRIPTION: "Depozitul a primit returul."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Expediere creată",
                        DESCRIPTION: "Depozitul a pregătit expedierea."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Expediere trimisă",
                        DESCRIPTION: "Depozitul a expediat articolele de schimb."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Notificarea de trimitere a expedierii a fost transmisă",
                    //     DESCRIPTION: "Notificarea de trimitere a expedierii a fost transmisă"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Expediere livrată",
                        DESCRIPTION: "Expedierea fost livrată."
                    },
                    REFUNDED: {
                        TITLE: "Rambursat",
                        DESCRIPTION: "Rambursarea a fost emisă."
                    },
                    CANCELLED: {
                        TITLE: "Anulat",
                        DESCRIPTION: "Solicitarea RMA a fost închisă."
                    },
                    CLOSED: {
                        TITLE: "Închis",
                        DESCRIPTION: "Solicitarea RMA a fost închisă."
                    },
                    REACHED: "Stare Atinsă",
                    UNREACHED: "Stare Neatinsă"
                },
                TIMELINE: {
                    TITLE: "Calendarul solicitării"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Tichete aferente",
                TICKET_NUMBER: "Număr tichet",
                CREATED_DATE: "Data creării",
                REQUEST_TYPES: "Tipuri de solicitări",
                STATUS: "Stare"
            }
        },
        ITEM: {
            LABEL: "Articol",
            ORDER_REFERENCE: {
                LABEL: "Referința comenzii"
            },
            RETURN_REASON: {
                LABEL: "Motivul returului"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Descrierea motivului returului"
            },
            CONDITION: {
                LABEL: "Condiție",
                VALUE: {
                    NEW: "Nou",
                    REFURBISHED: "Resigilat"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Referința comenzii",
            RETURN_REASON: "Motivul returului",
            RETURN_REASON_DESCRIPTION: "Descrierea motivului returului",
            CONDITION: {
                LABEL: "Condiție",
                VALUE: {
                    NEW: "Nou",
                    REFURBISHED: "Resigilat"
                }
            },
            TYPE: {
                RETURN: "Retur",
                REPLACEMENT: "Înlocuire"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "TRANSMITE"
            },
            CANCEL: {
                LABEL: "ANULEAZĂ"
            },
            SEARCH: {
                LABEL: "CAUTĂ"
            },
            CLOSE: {
                LABEL: "ÎNCHIDE"
            },
            HELP: {
                LABEL: "AJUTOR"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Înlocuire",
            REFUND: "Rambursare",
            RETURN_ONLY: "Numai retur",
            SHIP_ONLY: "Doar expediere"
        }
    },
    SE: {
        AUTHENTICATION: {
            TITLE: "Potrdite svoj e-poštni naslov",
            EMAIL_ADDRESS: {
                LABEL: "E-poštni naslov",
                ISSUE: {
                    INVALID: "Neveljaven e-poštni naslov"
                }
            }
        },
        TICKET_SEARCH: {
            TITLE: "Iskanje kartice",
            SUBTITLE: "Vnesite številko kartice in e-poštni naslov",
            TICKET_NUMBER: {
                LABEL: "Številka kartice",
                ISSUE: {
                    INVALID: "Neveljavna številka kartice"
                }
            },
            EMAIL_ADDRESS: {
                LABEL: "E-poštni naslov",
                ISSUE: {
                    INVALID: "Neveljaven e-poštni naslov"
                }
            },
            ISSUE: {
                NOT_FOUND: "Kartice ni bilo mogoče najti",
                ERROR: "Napaka"
            }
        },
        TICKET_CONFIRMATION: {
            TITLE: "Potrditvena stran za avtorizacijo vračila blaga",
            SUBTITLE: "Za začetek vračila izpolnite spodnji obrazec.",
            PERSONAL_INFORMATION: {
                TITLE: "Osebni podatki",
                FIRST_NAME: {
                    LABEL: "Ime"
                },
                LAST_NAME: {
                    LABEL: "Priimek"
                },
                EMAIL_ADDRESS: {
                    LABEL: "E-poštni naslov"
                },
                PHONE_NUMBER: {
                    LABEL: "Telefonska številka"
                }
            },
            REPLACEMENT_ADDRESS: {
                //TITLE: "Naslov za zamenjavo",
                TITLE: "Naslov",
                COUNTRY: {
                    LABEL: "Država"
                },
                FIRST_NAME: {
                    LABEL: "Ime"
                },
                LAST_NAME: {
                    LABEL: "Priimek"
                },
                ADDRESS_1: {
                    LABEL: "Naslov"
                },
                ADDRESS_2: {
                    LABEL: "AparStanovanje, apartma itd. (neobvezno)"
                },
                CITY: {
                    LABEL: "Mesto"
                },
                PROVINCE: {
                    LABEL: "Provinca"
                },
                POSTAL_CODE: {
                    LABEL: "Poštna številka"
                },
                RETURN_ADDRESS_SAME: {
                    LABEL: "Povratni naslov je enak"
                }
            },
            RETURN_ADDRESS: {
                TITLE: "Povratni naslov",
                COUNTRY: {
                    LABEL: "Država"
                },
                FIRST_NAME: {
                    LABEL: "Ime"
                },
                LAST_NAME: {
                    LABEL: "Priimek"
                },
                ADDRESS_1: {
                    LABEL: "Naslov"
                },
                ADDRESS_2: {
                    LABEL: "Stanovanje, apartma itd. (neobvezno)"
                },
                CITY: {
                    LABEL: "Mesto"
                },
                PROVINCE: {
                    LABEL: "Provinca"
                },
                POSTAL_CODE: {
                    LABEL: "Poštna številka"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Zahtevek",
                REQUEST_TYPE: {
                    LABEL: "Vrsta zahtevka"
                },
                RETURN_ITEMS: {
                    TITLE: "Izdelki, ki jih vračate"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Izdelki, ki jih boste prejeli"
                }
            },
            CONFIRMATION: {
                TITLE: "Potrditev",
                CUSTOMER_MESSAGE: {
                    TITLE: "Spoštovani uporabnik,",
                    STEPS: "1. Preglejte in potrdite podatke o svoji zahtevi.\r\n2. Preglejte in preverite svoj naslov.\r\n3. S klikom na spodnje potrditveno polje se strinjajte z zahtevo.\r\n4. Pošljite zahtevo s klikom na spodnji gumb POŠLJI.",
                    FOOTER: "Če imate kakršna koli vprašanja glede vaše zahteve ali potrebujete dodatno pomoč, obiščite spletno mesto HELP.KOBO.COM za druge možnosti stika in orodja za podporo."
                },
                CONFIRM_CHECKBOX: {
                    LABEL: "strinjam se z vračilom in prejemanjem izdelkov, navedenih v tej zahtevi."
                }
            }
        },
        TICKET: {
            TITLE: "Dovoljenje za vračilo blaga",
            GENERAL_INFORMATION: {
                TITLE: "Splošne informacije",
                UPDATE_ADDRESS: "Posodobi naslov",
                PERSONAL_INFORMATION: {
                    TITLE: "Osebni"
                },
                REPLACEMENT_ADDRESS: {
                    //TITLE: "Naslov za zamenjavo",
                    TITLE: "Naslov",
                    TITLE_SAME: "Naslov"
                },
                RETURN_ADDRESS: {
                    TITLE: "Povratni naslov",
                    SAME_AS_REPLACEMENT_ADDRESS: "Enako kot nadomestni naslov"
                }
            },
            REQUEST_DETAILS: {
                TITLE: "Zahtevek",
                REQUEST_TYPE: {
                    LABEL: "Vrsta zahtevka"
                },
                RETURN_ITEMS: {
                    TITLE: "Izdelki, ki jih vračate"
                },
                REPLACEMENT_ITEMS: {
                    TITLE: "Izdelki, ki jih boste prejeli"
                },
                TRACKING_INFORMATION: {
                    INBOUND: {
                        //LABEL: "Informacije o sledenju vračila"
                        LABEL: "Spårpaket"
                    },
                    OUTBOUND: {
                        //LABEL: "Informacije o sledenju zamenjave"
                        LABEL: "Spårpaket"
                    },
                    POPUP_BLOCKED_PREFIX: "Popup-fonster blockerat. Tillat popup-fonster for den har webbplatsen eller oppna sparningen ",
                    POPUP_BLOCKED_LINK_LABEL: "har"
                },
                DOWNLOAD_RETURN_LABEL: "Prenos nalepke za vračilo",
                RETURN_LABEL_PENDING: "Returmärke påvntande",
                STATUS: {
                    CURRENT_STATUS_DESCRIPTION: {
                        REPLACEMENT: {
                            CREATED:
                                "Prejeta je bila zahteva RMA.\r\nNalepke za vračilo bodo v kratkem pripravljene.\r\nKo bodo nalepke ustvarjene, boste prejeli e-poštno sporočilo z navodili za vračilo.\r\nNa tej strani boste lahko prenesli tudi nalepke za vračilo.",
                            RETURN_SHIPPED:
                                "Vrnjeni izdelki so bili poslani.\r\nPočakajte nekaj delovnih dni, da izdelki prispejo v naše skladišče.\r\nUpoštevajte: skladišče potrebuje nekaj delovnih dni za obdelavo zahtevka, ko izdelki pridejo v skladišče.",
                            RETURN_RECEIVED: "Vrnjeni izdelki so bili obdelani v skladišču.\r\nNadomestni izdelki bodo odposlani v nekaj delovnih dneh.",
                            SHIPMENT_SHIPPED: "Nadomestni izdelki so bili poslani.\r\nSpodaj si oglejte informacije o sledenju.",
                            SHIPMENT_DELIVERED: "Nadomestni izdelki so bili dostavljeni."
                        },
                        REFUND: {
                            CREATED:
                                "Prejeta je bila zahteva RMA.\r\nNalepke za vračilo bodo v kratkem pripravljene.\r\nKo bodo nalepke ustvarjene, boste prejeli e-poštno sporočilo z navodili za vračilo.\r\nNa tej strani boste lahko prenesli tudi nalepke za vračilo.",
                            RETURN_SHIPPED:
                                "Vrnjeni izdelki so bili poslani.\r\nPočakajte nekaj delovnih dni, da izdelki prispejo v naše skladišče.\r\nUpoštevajte: skladišče potrebuje nekaj delovnih dni za obdelavo zahtevka, ko izdelki pridejo v skladišče.",
                            RETURN_RECEIVED: "Vrnjeni izdelki so bili obdelani v skladišču.\r\nNadomestni izdelki bodo odposlani v nekaj delovnih dneh.",
                            REFUNDED: "Povračilo je bilo izdano."
                        },
                        SHIP_ONLY: {
                            CREATED: "Prejeta je bila zahteva RMA.\r\nNadomestni izdelki bodo poslani v nekaj delovnih dneh.",
                            SHIPMENT_SHIPPED: "Nadomestni izdelki so bili poslani.\r\nSpodaj si oglejte informacije o sledenju.",
                            SHIPMENT_DELIVERED: "Nadomestni izdelki so bili dostavljeni."
                        },
                        RETURN_ONLY: {
                            CREATED:
                                "Prejeta je bila zahteva RMA.\r\nNalepke za vračilo bodo v kratkem pripravljene.\r\nKo bodo nalepke ustvarjene, boste prejeli e-poštno sporočilo z navodili za vračilo.\r\nNa tej strani boste lahko prenesli tudi nalepke za vračilo.",
                            RETURN_SHIPPED:
                                "Vrnjeni izdelki so bili poslani.\r\nPočakajte nekaj delovnih dni, da izdelki prispejo v naše skladišče.\r\nUpoštevajte: skladišče potrebuje nekaj delovnih dni za obdelavo zahtevka, ko izdelki pridejo v skladišče.",
                            RETURN_RECEIVED: "Vrnjeni izdelki so bili obdelani v skladišču."
                        }
                    },
                    CREATED: {
                        TITLE: "Ustvarjeno",
                        DESCRIPTION: "Zahteva RMA je ustvarjena."
                    },
                    ADDRESS_VERIFICATION_NOTICE_SENT: {
                        TITLE: "Obvestilo o preverjanju naslova poslano",
                        DESCRIPTION: "E-poštno sporočilo za preverjanje naslova je bilo poslano na vaš e-poštni naslov."
                    },
                    ADDRESS_VERIFIED: {
                        TITLE: "Preverjen naslov",
                        DESCRIPTION: "Naslov je preverjen."
                    },
                    RETURN_WAYBILL_CREATED: {
                        TITLE: "Ustvarjena nalepka za vračilo",
                        DESCRIPTION: "Nalepke za vračila so bile ustvarjene."
                    },
                    // RETURN_NOTICE_SENT: {
                    //     TITLE: "Obvestilo o vračilu poslano",
                    //     DESCRIPTION: "Nalepke za vračilo in navodila so bila poslana na vaš e-poštni naslov."
                    // },
                    // RETURN_FINAL_NOTICE_SENT: {
                    //     TITLE: "Končno obvestilo o vračilu poslano",
                    //     DESCRIPTION: "Opomnik za vračilo je bil poslan na vaš e-poštni naslov."
                    // },
                    RETURN_SHIPPED: {
                        TITLE: "Vračilo poslano",
                        DESCRIPTION: "Vračilo je bilo poslano."
                    },
                    RETURN_RECEIVED: {
                        TITLE: "Vračilo prejeto",
                        DESCRIPTION: "Skladišče je prejelo vrnjene izdelke."
                    },
                    // RETURN_RECEIVED_NOTICE_SENT: {
                    //     TITLE: "Obvestilo o prejetem vračilu poslano",
                    //     DESCRIPTION: "Skladišče je prejelo vračilo."
                    // },
                    SHIPMENT_CREATED: {
                        TITLE: "Pošiljka ustvarjena",
                        DESCRIPTION: "Skladišče je pripravilo pošiljko."
                    },
                    SHIPMENT_SHIPPED: {
                        TITLE: "Odprema pošiljke",
                        DESCRIPTION: "Skladišče je poslalo nadomestne izdelke."
                    },
                    // SHIPMENT_SHIPPED_NOTICE_SENT: {
                    //     TITLE: "Obvestilo o odpremi pošiljke poslano",
                    //     DESCRIPTION: "Obvestilo o odpremi pošiljke poslano"
                    // },
                    SHIPMENT_DELIVERED: {
                        TITLE: "Pošiljka dostavljena",
                        DESCRIPTION: "Pošiljka je bila dostavljena."
                    },
                    REFUNDED: {
                        TITLE: "Vračilo kupnine",
                        DESCRIPTION: "Vračila kupnine so bila izdana."
                    },
                    CANCELLED: {
                        TITLE: "Preklicano",
                        DESCRIPTION: "Zahteva RMA je zaključena."
                    },
                    CLOSED: {
                        TITLE: "Zaprto",
                        DESCRIPTION: "Zahteva RMA je zaključena."
                    },
                    REACHED: "Status Uppnådd",
                    UNREACHED: "Status Ej Uppnådd"
                },
                TIMELINE: {
                    TITLE: "Časovnica zahtevka"
                }
            },
            RELATED_TICKETS: {
                TITLE: "Relaterade Kartice",
                TICKET_NUMBER: "Številka kartice",
                CREATED_DATE: "Ustvarjeno dne",
                REQUEST_TYPES: "Vrste zahtevkov",
                STATUS: "Stanje"
            }
        },
        ITEM: {
            LABEL: "Izdelek",
            ORDER_REFERENCE: {
                LABEL: "Referenca naročila"
            },
            RETURN_REASON: {
                LABEL: "Razlog za vračilo"
            },
            RETURN_REASON_DESCRIPTION: {
                LABEL: "Opis razloga za vračilo"
            },
            CONDITION: {
                LABEL: "Stanje",
                VALUE: {
                    NEW: "Novo",
                    REFURBISHED: "Prenovljeno"
                }
            }
        },
        ITEM_DETAILS: {
            TITLE: "Item Details",
            ORDER_REFERENCE: "Referenca naročila",
            RETURN_REASON: "Razlog za vračilo",
            RETURN_REASON_DESCRIPTION: "Opis razloga za vračilo",
            CONDITION: {
                LABEL: "Stanje",
                VALUE: {
                    NEW: "Novo",
                    REFURBISHED: "Prenovljeno"
                }
            },
            TYPE: {
                RETURN: "Vračilo",
                REPLACEMENT: "Zamenjava"
            }
        },
        BUTTON: {
            SUBMIT: {
                LABEL: "POŠLJI"
            },
            CANCEL: {
                LABEL: "PREKLIČI"
            },
            SEARCH: {
                LABEL: "IŠČI"
            },
            CLOSE: {
                LABEL: "ZAPRI"
            },
            HELP: {
                LABEL: "HJÄLP"
            }
        },
        REQUEST_TYPE: {
            REPLACEMENT: "Zamenjava",
            REFUND: "Povračilo",
            RETURN_ONLY: "Samo vračilo",
            SHIP_ONLY: "Samo pošiljanje"
        }
    }
};
